<template>
  <!-- 导出国家级报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button> -->
    <div class="analysisReport_box" id="pdfPrint">
      <!-- PDF  首页 -->
      <div class="HomePage">
        <!-- 图片 -->
        <div id="image"></div>
        <!-- 正文 -->
        <div id="PdfTitle">
          <p id="FristTitle">国家职业教育智慧教育平台专业与课程服务中心</p>
          <div>
            <p id="SecondTitle" v-show="this.$route.query.type == 1">建设与应用监测年度分析报告</p>
            <p id="SecondTitle" v-show="this.$route.query.type == 2">
              建设与应用监测半年度分析报告
            </p>
          </div>
          <p id="FourTitle">
            运行分析起止时间：{{ this.$route.query.startDay }} 至 {{ this.$route.query.endDay }}
            <input v-show="false" v-model="completeMathodNum" id="completeMathodNum" />
          </p>
        </div>
        <!-- 底部 -->
        <div id="foot">
          <div class="footBox">
            <p>国家职业教育智慧教育平台专业与课程服务中心监测平台项目组</p>
            <p>教育大数据应用技术国家工程研究中心</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 10 日
            </p>
          </div>
        </div>
      </div>

      <!-- 目录 -->
      <div class="catalogue">
        <div class="title">
          <p style="font-size: 60px">
            目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录
          </p>
        </div>

        <!-- 第一部分盒子 -->
        <div class="Frist">
          <!-- 第一块区域 -->
          <h5 class="title_text">
            1.
            监测总览................................................................................................1
          </h5>
          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              1.1
              总体建设及应用分析...................................................................1
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.1.1 用户建设及应用.............................................................1
              </h5>
              <h5>
                1.1.2 课程建设及应用.............................................................2
              </h5>
              <h5>
                1.1.3 资源建设及应用.............................................................3
              </h5>
            </div>
          </div>

          <div class="Second_text">
            <h5 style="text-indent: 1.8em">
              1.2
              各省市建设及应用情况分析................................................................4
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.2.1 各省用户建设及应用.....................................................4
              </h5>
              <h5>
                1.2.2 各省课程建设及应用.....................................................5
              </h5>
              <h5>
                1.2.3 各省资源建设及应用.....................................................5
              </h5>
            </div>
          </div>

          <div class="Thred_text">
            <h5 style="text-indent: 1.8em">
              1.3 {{ nowYear }} 年度数据运行监测分析....................................6
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                1.3.1
                用户运行情况.........................................................................6
              </h5>
              <h5>
                1.3.2
                课程运行情况.........................................................................7
              </h5>
              <h5>
                1.3.3
                资源运行情况.........................................................................7
              </h5>
            </div>
          </div>
        </div>

        <!-- 第二部分盒子 -->
        <div class="Second">
          <h5>
            2.职业教育专业教学资源库运行监测分析......................................................................8
          </h5>
          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              2.1
              203个国家级资源库建设与应用分析........................................................8
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                2.1.1
                用户建设及应用分析.............................................................8
              </h5>
              <h5>
                2.1.2
                课程建设及应用分析..............................................................9
              </h5>
              <h5>
                2.1.3
                资源建设及应用分析............................................................10
              </h5>
              <h5>
                2.2.4
                按专业大类汇总统计维度分析............................................................11
              </h5>
              <div style="text-indent: 8em">
                <h5>2.1.4.1 装备制造大类专业教学资源库建设与应用数据分析...12</h5>
                <h5>2.1.4.2 电子与信息大类专业教学资源库建设与应用数据分析...13</h5>
                <h5>2.2.4.3 交通运输大类专业教学资源库建设与应用数据分析...14</h5>
                <h5>2.2.4.4 财经商贸大类专业教学资源库建设与应用数据分析...15</h5>
              </div>
              <h5>
                2.1.5 各省国家级资源库建设与应用情况........................................16
              </h5>
              <div style="text-indent: 7.69em">
                <h5>
                  2.1.5.1
                  各省国家级资源库建设与应用情况概览.....................................................17
                </h5>
                <h5>
                  2.1.5.2
                  各省国家级资源库用户建设与应用情况.....................................................18
                </h5>
                <h5>
                  2.1.5.3
                  各省国家级资源库课程建设及应用情况.....................................................19
                </h5>
                <h5>
                  2.1.5.4
                  各省国家级资源库资源建设及应用情况.....................................................20
                </h5>
              </div>
            </div>
          </div>

          <div class="Frist_text">
            <h5 style="text-indent: 1.8em">
              2.2. 各省利用资源库开展教学总体情况..........................................12
            </h5>
            <div style="text-indent: 7.69em">
              <h5>
                2.2.1 各省用户建设及应用情况.....................................................12
              </h5>
              <h5>
                2.2.2 各省课程建设及应用情况.....................................................13
              </h5>
              <h5>
                2.2.3 各省资源建设及应用情况.....................................................13
              </h5>
            </div>
          </div>
          <div class="Frist_text" style="margin-top: 550px">
            <h5 style="text-indent: 1.8em">
              2.3 {{ this.$route.query.startDay }} 至
              {{ this.$route.query.endDay }}资源库运行情况分析........................14
            </h5>
            <div class="div" style="text-indent: 7.69em">
              <h5>
                2.3.1
                资源库用户运行情况.............................................................14
              </h5>
              <h5>
                2.3.2
                资源库课程运行情况.............................................................15
              </h5>
              <h5>
                2.3.3
                资源库资源运行情况.............................................................16
              </h5>
              <h5>
                2.3.4
                国家级资源库运行情况.........................................................17
              </h5>
            </div>
          </div>
        </div>

        <!-- 第三部分盒子 -->
        <div class="Third">
          <h5>
            3.
            在线精品课应用分析.............................................................................11
          </h5>
          <div class="Frist_text">
            <div class="div" style="text-indent: 1.8em">
              <h5>
                3.1
                在线精品课建设情况........................................................................21
              </h5>
              <h5>
                3.2
                在线精品课访问情况........................................................................21
              </h5>
              <h5>
                3.3
                在线精品课开课情况........................................................................22
              </h5>
              <h5>
                3.4
                在线精品课选课情况........................................................................22
              </h5>
            </div>
          </div>
        </div>

        <!-- 第四部分盒子 -->
        <div class="Fourth">
          <h5>
            4.
            视频公开课应用分析.............................................................................23
          </h5>
          <div class="Frist_text">
            <div class="div" style="text-indent: 1.8em">
              <h5>
                4.1
                视频公开课建设情况........................................................................23
              </h5>
              <h5>
                4.2
                视频公开课访问情况........................................................................23
              </h5>
              <h5>
                4.3
                视频公开课选课情况........................................................................24
              </h5>
            </div>
          </div>
        </div>
      </div>

      <div class="header_titles" style="margin-top: 1300px">
        <h1 style="margin-top: 100px">国家职业教育智慧教育平台专业与课程服务中心</h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 1">
          {{ nowYear }}年{{ nowMonth }}月建设与应用监测分析报告
        </h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 2">
          {{ nowYear }}年{{ Quarter }}建设与应用监测分析报告
        </h1>
        <h1 style="margin-top: 20px" v-show="this.$route.query.type == 3">
          {{ nowYear }}年建设与应用监测分析报告
        </h1>
        <div class="number_time">
          <div>
            <span></span>
            <span
              >统计时间：{{ this.$route.query.startDay }} 至 {{ this.$route.query.endDay }}</span
            >
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <div class="chart_box">
        <h3>1. 监测总览</h3>
        <p style="margin-top: 20px">
          2022年3月28日，国家职业教育智慧教育平台上线，国家级专业教学资源库与国家在线精品课程合并为专业与课程服务中心。专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对专业教学资源库、
          在线精品课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，国家职业教育智慧教育平台专业与课程监测中心共接入专业教学资源库{{
            dataAll.dataList.zykNum
          }}个，在线精品课{{ dataAll.dataList.onlineCourseNum }}门，视频公开课{{
            dataAll.dataList.videoCourseNum
          }}门， 覆盖平台数有{{ dataAll.dataList.platForm }}个，专业与课程服务中心累计用户访问量达{{
            dataAll.dataList.totalVisitNum > 1000000000
              ? (dataAll.dataList.totalVisitNum / 100000000).toFixed(2) + "亿"
              : dataAll.dataList.totalVisitNum
          }}，用户数{{
            userTypeHand.total > 10000
              ? (userTypeHand.total / 10000).toFixed(2) + "万"
              : userTypeHand.total
          }}；参与建设的院校有{{ dataAll.dataList.schoolNum }}所；参建企业有{{
            dataAll.dataList.companyNum
          }}家； 覆盖专业数{{ dataAll.dataList.totalProfessionCount }}个，其中高职专业数{{
            dataAll.dataList.height_edu
          }}个，中职专业数{{ dataAll.dataList.middle_edu }}个。
        </p>
      </div>

      <div class="chart_box">
        <h4>1.1 总体建设及应用分析</h4>
        <div class="chart_box">
          <h5>1.1.1 用户建设及应用情况</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
                userTypeHand.total > 10000
                  ? (userTypeHand.total / 10000).toFixed(2) + "万"
                  : userTypeHand.total
              }}，其中学生总数最多，共{{
                (this.userTypeHand.studentNum / 10000).toFixed(2)
              }}万，占比{{
                ((this.userTypeHand.studentNum / this.userTypeHand.total) * 100).toFixed(2)
              }}%， 其次是教师总数，共{{
                (this.userTypeHand.tearchNum / 10000).toFixed(2)
              }}万，占比{{
                ((this.userTypeHand.tearchNum / this.userTypeHand.total) * 100).toFixed(2)
              }}%。具体情况如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="userTypeHand.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 1 用户类型分布</div>
          </div>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，近一年学生用户访问总量达{{
                userTalk.studentTotal
              }}次，教师用户访问量达{{ userTalk.teacherTotal }}次，具体访问趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="userTalk.dataList"
                :transverseData="userTalk.transverse"
                :colorList="userTalk.colorList"
                :innerText="'单位：次'"
                :legendList="userTalk.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 2 最近一年教师和学生访问情况</div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 420px">
          <h5>1.1.2 课程建设及应用情况</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心共计{{
                courseTypeNum.total > 10000
                  ? (courseTypeNum.total / 10000).toFixed(2) + "万"
                  : courseTypeNum.total
              }}门课程，其中资源库的课程数量最多，占比{{
                ((this.courseTypeNum.maxArr.value / this.courseTypeNum.total) * 100).toFixed(2)
              }}%，具体课程来源分布如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="courseTypeNum.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 3 课程来源分布</div>
          </div>

          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，近一年课程被访问总量达{{
                courseTalk.total > 10000000
                  ? (courseTalk.total / 100000000).toFixed(2) + "亿"
                  : (courseTalk.total / 10000).toFixed(2) + "万"
              }}次，平均月访问量达{{
                courseTalk.total / 12 > 100000000
                  ? (courseTalk.total / 12 / 100000000).toFixed(2) + "亿"
                  : (courseTalk.total / 12 / 10000).toFixed(2) + "万"
              }}次，具体访问趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="courseTalk.dataList"
                :transverseData="courseTalk.transverseData"
                :colorList="courseTalk.colorList"
                :innerText="'单位：次'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 4 近一年课程被访问趋势图</div>
          </div>

          <div class="chart_box">
            <p>
              据监测平台统计，截止到{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日，被访问量居首的课程是《{{ courseTalkTable.MaxArr.courseName }}》，有{{
                courseTalkTable.MaxArr.courseTotalVisit > 100000000
                  ? (courseTalkTable.MaxArr.courseTotalVisit / 100000000).toFixed(2) + "亿"
                  : (courseTalkTable.MaxArr.courseTotalVisit / 10000).toFixed(2) + "万"
              }}次，具体课程被访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程名称</th>
                  <th>课程来源</th>
                  <th>平台</th>
                  <th>课程负责人</th>
                  <th>建设院校</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in courseTalkTable.dataList"
                  :key="index"
                  v-show="courseTalkTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.courseName }}</td>
                  <td>{{ item.courseType }}</td>
                  <td>{{ item.platform }}</td>
                  <td>{{ item.majorTeacher }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.courseTotalVisit }}</td>
                </tr>

                <tr v-show="courseTalkTable.dataList.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 1 课程被访问量排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box">
          <h5>1.1.3 资源建设及应用情况</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，专业与课程服务中心资源总数达{{
                this.educationLevel.total < 100000000
                  ? (this.educationLevel.total / 10000).toFixed(2) + "万"
                  : this.educationLevel.total
              }}条，共计容量有{{ formatValue(getResource.resourceCapacityNum / 1024 / 1024) }}TB。
              从资源类型来看，{{ this.educationLevel.video.name }}类数量最多，有{{
                (this.educationLevel.video.value / 10000).toFixed(2)
              }}万条，占比{{
                ((this.educationLevel.video.value / this.educationLevel.total) * 100).toFixed(2)
              }}%，具体资源类型分布如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="educationLevel.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 5 资源类型分布</div>
          </div>
          <div class="chart_box">
            <p>
              资源访问总量已达{{
                educationLevel.totalVisitNum > 100000000
                  ? (educationLevel.totalVisitNum / 100000000).toFixed(2) + "亿"
                  : (educationLevel.totalVisitNum / 12 / 10000).toFixed(2) + "万"
              }}次，日均访问资源{{
                getDailyVist(educationLevel.totalVisitNum)
              }}，其中访问次数最多的资源是《{{
                resourceTable.Max.split(",")[0]
              }}》，资源被访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th style="width: 300px">资源名称</th>
                  <th>资源类型</th>
                  <th>资源来源</th>
                  <th>上传人</th>
                  <th>建设院校</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in resourceTable.dataList"
                  :key="index"
                  v-show="resourceTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name.split(",")[0] }}</td>
                  <td>{{ item.name.split(",")[1] }}</td>
                  <td>{{ item.zykName }}</td>
                  <td>{{ item.author }}</td>
                  <td>{{ item.school }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="resourceTable.dataList.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 300px">
              表 2 资源被访问量排名（前十五名）
            </div>
          </div>
        </div>
      </div>
      <div class="chart_box">
        <h4>1.2 各省市建设及应用情况</h4>
        <div class="chart_box">
          <h5>1.2.1 各省用户建设及应用情况</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
                getUser.userTotal > 10000
                  ? (getUser.userTotal / 10000).toFixed(2) + "万"
                  : getUser.userTotal + "万"
              }}，来自31个省份，其中注册用户最多的是{{ getUser.MaxArr.name }}省， 达{{
                (getUser.MaxArr.value / 10000).toFixed(2) + "万"
              }}用户之多；在线学习总人数有{{
                this.provinceStudy.total > 10000
                  ? (this.provinceStudy.total / 10000).toFixed(2) + "万"
                  : this.provinceStudy.total
              }}，在线学习人数最多的则是{{ provinceStudy.MaxArr.name }}省，共{{
                provinceStudy.MaxArr.value > 10000
                  ? (provinceStudy.MaxArr.value / 10000).toFixed(2) + "万"
                  : provinceStudy.MaxArr.value
              }}人； 互动交流次数累计{{
                provinceTalking.total > 100000000
                  ? (provinceTalking.total / 100000000).toFixed(2) + "亿"
                  : (provinceTalking.total / 10000).toFixed(2) + "万"
              }}次，互动交流频次最多的是{{ provinceTalking.MaxArr.name }}，其次是{{
                provinceTalking.SecArr.name
              }}。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="getUser.dataList"
                :transverseData="getUser.legendList"
                :colorList="getUser.colorList"
                style="height: 140%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 190px">
              图 6 各省注册用户数排名（前十五名）
            </div>
            <!-- <div style="height: 540px;"></div> -->

            <!-- <div style="height: 50px;" v-show="this.$route.query.endDay == '2022-10-31'"></div> -->

            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="provinceStudy.dataList"
                :transverseData="provinceStudy.legendList"
                :colorList="provinceStudy.colorList"
                style="height: 140%; width: 110%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 190px">
              图 7 各省在线学习人数排名（前十五名）
            </div>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="provinceTalking.dataList"
                :transverseData="provinceTalking.legendList"
                :colorList="provinceTalking.colorList"
                style="height: 140%; width: 110%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 190px">
              图 8 各省交流互动量排名（前十五名）
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h5>1.2.2 各省课程建设及应用情况</h5>
          <div class="chart_box">
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，有31个省份参与建设课程，总计{{
                curriculum.totalCourse > 10000
                  ? (curriculum.totalCourse / 10000).toFixed(2) + "万"
                  : curriculum.totalCourse
              }}门，其中建设课程数量最多的是{{ curriculum.MaxArr.name }}省， 总计建设{{
                (curriculum.MaxArr.value / 10000).toFixed(2) + "万"
              }}门课程。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="curriculum.dataList"
                :transverseData="curriculum.legendList"
                :colorList="curriculum.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 220px">
              图 9 各省建设课程数量排名（前十五名）
            </div>

            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="teacherProvince.dataList"
                :transverseData="teacherProvince.legendList"
                :colorList="teacherProvince.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 220px">
              图 10 各省参与建设教师数排名（前十五名）
            </div>
          </div>

          <div class="chart_box">
            <h5>1.2.3 各省资源建设及应用情况</h5>
            <div class="chart_box">
              <p>
                截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设资源总数{{
                  sourceMater.resourceTotalCount > 100000000
                    ? (sourceMater.resourceTotalCount / 100000000).toFixed(2) + "亿"
                    : (sourceMater.resourceTotalCount / 10000).toFixed(2) + "万"
                }}条，共有31个省份参与建设， 其中建设资源数量最多的是{{
                  sourceMater.MaxArr.province
                }}省，有{{
                  sourceMater.MaxArr.num > 10000
                    ? (sourceMater.MaxArr.num / 10000).toFixed(2) + "万"
                    : sourceMater.MaxArr.num
                }}条。 各省访问资源的总量达{{
                  visitProvince.total > 100000000
                    ? (visitProvince.total / 100000000).toFixed(2) + "亿"
                    : (visitProvince.total / 10000).toFixed(2) + "万"
                }}次，访问资源总量最多的是{{ visitProvince.MaxArr.name }}省。
              </p>
              <div class="standards_content echartsHeight">
                <tcolumnarChart
                  :refId="'coursesOfferedChart'"
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :datas="sourceMater.dataList"
                  :transverseData="sourceMater.legendList"
                  :colorList="sourceMater.colorList"
                  style="height: 160%"
                  :gridY="'4%'"
                ></tcolumnarChart>
              </div>
              <div class="chart_name" style="margin-top: 220px">
                图 11 各省建设资源数排名（前十五名）
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="chart_box">
          <div class="standards_content echartsHeight">
            <tcolumnarChart
              :refId="'coursesOfferedChart'"
              :isExportTextColor="true"
              :isShowTextColor="true"
              :datas="visitProvince.dataList"
              :transverseData="visitProvince.legendList"
              :colorList="visitProvince.colorList"
              style="height: 160%"
              :gridY="'4%'"
            ></tcolumnarChart>
          </div>
          <div class="chart_name" style="margin-top: 220px">
            图 12 各省访问资源数排名（前十五名）
          </div>
        </div>

        <div class="chart_box" style="margin-top: 100px">
          <h4>1.3 {{ nowYear }}年度数据运行监测分析</h4>
          <div class="chart_box">
            <h5>1.3.1 用户运行分析</h5>
            <div class="chart_box">
              <p>
                {{ nowYear }}年新增注册用户累计{{
                  userAdd.total > 10000 ? (userAdd.total / 10000).toFixed(2) + "万" : userAdd.total
                }}名，注册用户趋势图如下所示：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="userAdd.dataList1"
                  :transverseData="userAdd.transverse"
                  :colorList="userAdd.colorList"
                  :legendList="userAdd.legendList"
                  :innerText="'单位：名'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="standards_content echartsHeight" style="margin-top: 100px">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'visitsMonthChart'"
                  :datas="userAdd.dataList2"
                  :transverseData="userAdd.transverse"
                  :colorList="userAdd.colorList"
                  :legendList="userAdd.tran"
                  :innerText="'单位：名'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name" style="margin-top: 20px">图 13 注册用户趋势图</div>
            </div>

            <div class="chart_box" style="margin-top: 100px">
              <p>
                {{ nowYear }}年总用户访问量累计达{{
                  userTimeTalk.total > 100000000
                    ? (userTimeTalk.total / 100000000).toFixed(2) + "亿"
                    : (userTimeTalk.total / 10000).toFixed(2) + "万"
                }}次，用户访问量趋势图如下所示：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'resourcesMonthChart'"
                  :datas="userTimeTalk.dataList"
                  :transverseData="userTimeTalk.transverse"
                  :colorList="userTimeTalk.colorList"
                  :innerText="'单位：次'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">图 14 用户被访问趋势图</div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="chart_box" style="margin-top: 420px">
          <h5>1.3.2 课程运行分析</h5>
          <div class="chart_box">
            <div class="chart_box">
              <p>
                {{ nowYear }}年新增课程数为{{
                  courseNew.total > 10000
                    ? (courseNew.total / 10000).toFixed(2) + "万"
                    : courseNew.total
                }}门，课程被访问次数达{{
                  courseTrend.total > 100000000
                    ? (courseTrend.total / 100000000).toFixed(2) + "亿"
                    : (courseTrend.total / 10000).toFixed(2) + "万"
                }}次，课程运行趋势如下图所示：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'resourcesMonthChart'"
                  :datas="courseNew.dataList"
                  :transverseData="courseNew.transverse"
                  :colorList="courseNew.colorList"
                  :colorName="1"
                  :innerText="'单位：门'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">图 15 新增课程趋势图</div>
            </div>

            <div class="chart_box" style="margin-top: 100px">
              <div class="standards_content echartsHeight">
                <discountChart
                  :isExportTextColor="true"
                  :isShowTextColor="true"
                  :refId="'resourcesMonthChart'"
                  :datas="courseTrend.dataList"
                  :transverseData="courseTrend.transverse"
                  :colorList="courseTrend.colorList"
                  :colorName="1"
                  :innerText="'单位：次'"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">图 16 课程被访问趋势图</div>
            </div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 100px">
          <h5>1.3.3 资源运行分析</h5>
          <div class="chart_box">
            <p>
              {{ nowYear }}年新增资源数累计{{
                resourceNew.total > 10000
                  ? (resourceNew.total / 10000).toFixed(2) + "万"
                  : resourceNew.total
              }}条，资源被访问次数累计达{{
                resourceVisits.total > 10000
                  ? (resourceVisits.total / 10000).toFixed(2) + "万"
                  : resourceVisits.total
              }}次，资源运行趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="resourceNew.dataList"
                :transverseData="resourceNew.transverse"
                :colorList="colorList"
                :innerText="'单位：条'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 17 新增资源趋势图</div>
          </div>

          <div class="chart_box" style="margin-top: 100px">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'resourcesMonthChart'"
                :datas="resourceVisits.dataList"
                :transverseData="resourceVisits.transverse"
                :colorList="resourceVisits.colorList"
                :innerText="'单位：次'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 18 资源被访问趋势图</div>
          </div>
        </div>
      </div>

      <div class="chart_box" style="margin-top: 120px">
        <h3 style="margin-bottom: 25px">2. 职业教育专业教学资源库运行监测分析</h3>
        <h4 style="margin-bottom: 25px">2.1 203个国家级资源库建设与应用分析</h4>
        <p>
          国家级职业教育专业教学资源库已立项建设项目共计
          {{ twoGetCountry.zykCountryNum }} 个，覆盖了所有专业大类和 156 个二级专业类。 目前，已有{{
            twoGetCountry.schoolBuild
          }}
          所职业院校和{{ twoGetCountry.companyBuild }}家行业企业参与建设；标准课程总量已达{{
            twoGetCountry.standardNum
          }}门，资源库项目资源总量达{{
            twoGetCountry.resourceNum > 100000000
              ? (twoGetCountry.resourceNum / 100000000).toFixed(2) + "亿"
              : (twoGetCountry.resourceNum / 10000).toFixed(2) + "万"
          }}余条，资源库共有注册用户
          {{
            twoGetCountry.zykUserNum > 100000000
              ? (twoGetCountry.zykUserNum / 100000000).toFixed(2) + "亿"
              : (twoGetCountry.zykUserNum / 10000).toFixed(2) + "万"
          }}余人，总访问次数{{
            twoGetCountry.totalZykVisitNum > 100000000
              ? (twoGetCountry.totalZykVisitNum / 100000000).toFixed(2) + "亿"
              : (twoGetCountry.totalZykVisitNum / 10000).toFixed(2) + "万"
          }}次
        </p>
        <div class="chart_box">
          <h5>2.1.1 用户建设及应用分析</h5>
          <p>
            当前，国家级职业教育专业教学资源库共有注册用户{{
              userTypeList.total > 10000
                ? (userTypeList.total / 10000).toFixed(2) + "万"
                : userTypeList.total
            }}余人，按用户身份类型统计，{{ userConstruction.tearchNum.name
            }}{{
              userConstruction.tearchNum.value > 10000
                ? (userConstruction.tearchNum.value / 10000).toFixed(2) + "万"
                : userConstruction.tearchNum.value
            }}余人，{{ userConstruction.studentNum.name
            }}{{
              userConstruction.studentNum.value > 10000
                ? (userConstruction.studentNum.value / 10000).toFixed(2) + "万"
                : userConstruction.studentNum.value
            }}余人。资源库建设较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有{{
              userConstruction.socialNum.name
            }}{{
              userConstruction.socialNum.value > 10000
                ? (userConstruction.socialNum.value / 10000).toFixed(2) + "万"
                : userConstruction.socialNum.value
            }}余人，充分说明资源库的建设和应用了承担了面向普通劳动者的免费线上培训的社会责任。
          </p>
          <p>
            资源库总体用户访问资源总量约{{
              talkAll.resource > 100000000
                ? (talkAll.resource / 100000000).toFixed(2) + "亿"
                : (talkAll.resource / 10000).toFixed(2) + "万"
            }}次、用户访问课程总量约{{
              talkAll.course > 100000000
                ? (talkAll.course / 100000000).toFixed(2) + "亿"
                : (talkAll.course / 10000).toFixed(2) + "万"
            }}次，用户互动交流次数约{{
              talkAll.user > 100000000
                ? (talkAll.user / 100000000).toFixed(2) + "亿"
                : (talkAll.user / 10000).toFixed(2) + "万"
            }}次。
          </p>
          <p>具体用户分布详情如下所示：</p>
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="userTypeList.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 19 用户整体情况（单位：人）</div>
          </div>
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="studentConstruction.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 20 学生类型整体情况（单位：人）</div>
          </div>
          <!-- <div class="chart_box">
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="userTalk.dataList"
                :transverseData="userTalk.transverse"
                :colorList="userTalk.colorList"
                :innerText="'单位：次'"
                :legendList="userTalk.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 21 最近一年教师和学生访问情况</div>
          </div> -->
          <!-- <div
            class="chart_box"
            style="margin-top: 425px;"
          >
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'userTalk'"
                :datas="socialAndenterprise.dataList"
                :transverseData="socialAndenterprise.transverse"
                :colorList="socialAndenterprise.colorList"
                :innerText="'单位：次'"
                :legendList="socialAndenterprise.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 22 最近一年社会学习者和企业用户访问情况</div>
          </div> -->
        </div>

        <div class="chart_box" style="margin-top: 150px">
          <h5>2.1.2 课程建设及应用分析</h5>
          <div class="chart_box">
            <p>
              当前，国家级职业教育专业教学资源库课程建设总量达到{{
                getUtils_Fun(getcourse.courseNum)
              }}门，其中标准化课程{{
                getcourse.dataList[0] > 10000
                  ? (getcourse.dataList[0] / 10000).toFixed(2) + "万"
                  : getcourse.dataList[0]
              }}门，个性化课程{{
                getcourse.dataList[1] > 10000
                  ? (getcourse.dataList[1] / 10000).toFixed(2) + "万"
                  : getcourse.dataList[1]
              }}门，课程访问日均次数{{ getcourse.CourseDayVisitNum }}次, 注册学生数最多的课程名《{{
                getcourse.courseMaxCount.name
              }}》是属于{{ getcourse.courseMaxCount.zykName }}资源库。{{
                getcourse.courseMaxCount.zykDiv
              }}%资源库中的项目课程(标准化课程)数量大于 10 门，课程按类型分布详情如下
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="getcourse.dataList"
                :transverseData="getcourse.transverseData"
                :colorList="getcourse.colorList"
              ></tcolumnarChart>
            </div>
          </div>
          <div class="chart_name">图 23 课程整体情况（单位：门）</div>
        </div>

        <!-- <div
          class="chart_box"
          style="margin-top: 50px;"
        >
          <div class="standards_content echartsHeight">
            <discountChart
              :isExportTextColor="true"
              :isShowTextColor="true"
              :refId="'userTalk'"
              :datas="courseTalk.dataList"
              :transverseData="courseTalk.transverseData"
              :colorList="courseTalk.colorList"
              :innerText="'单位：次'"
              :titleLeft="'32%'"
              :legendBackgroundColor="true"
              :legendLeft="'60%'"
              :circleSize="80"
              :isaverage="true"
            ></discountChart>
          </div>
          <div class="chart_name">图 24 最近一年课程访问情况</div>
        </div> -->
      </div>

      <div>
        <div class="chart_box" style="margin-top: 750px">
          <h5>2.1.3 资源建设及应用分析</h5>
          <p>
            当前，国家级职业教育专业教学资源库资源数量达{{
              getUtils_Fun(educationLevel.resourceNum)
            }}余条，
            资源总量不断扩大，解决了传统教学中“讲不清、看不到、进不去、动不得、难再现”的问题；表现形式日趋丰富，更受年轻人喜爱的视频类教学资源数量独占鳌头，达到{{
              getUtils_Fun(educationLevel.video.value)
            }}个，除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
              getUtils_Fun(educationLevel.xuni.value)
            }}个虚拟仿真资源, 资源总容量达
            {{
              formatValue(educationLevel.resourceCapacityNum / 1024 / 1024)
            }}TB，资源访问总量已达{{ getUtils_Fun(educationLevel.resourceTotal) }}余次，日均访问资源
            {{ getUtils_Fun(educationLevel.resourceAvg) }}次。;
          </p>
          <p>
            其中访问次数最多的资源是《{{ educationLevel.visitMaxResource.name }}》，属于{{
              educationLevel.visitMaxResource.zykName
            }}。资源按类型分布详情如下：
          </p>
          <div class="chart_box">
            <!-- <p>资源按类型分布详情如下：</p> -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="educationLevel.dataList"
                :transverseData="educationLevel.transverseData"
                :colorList="educationLevel.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图 25 资源整体情况（单位：条）</div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 420px">
          <h5>2.1.4 按专业大类汇总统计维度分析</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库覆盖{{
                getmajor.dataList.length - 1
              }}个专业大类。从专业大类分布看，属于{{ getmajor.MaxArr.name }}的资源库最多，占比达{{
                ((getmajor.MaxArr.value / getmajor.total) * 100).toFixed(2)
              }}%，具体可归属专业大类的资源库分布如下图所示：
            </p>
            <div class="standards_content echartsHeight" style="width: 1700px">
              <circularChart
                :refId="'typeDistributionChart'"
                :isShowTextColor="true"
                :datas="getmajor.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'50%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 26 专业大类分布情况</div>
            <p>
              每个专业大类下属资源库的应用情况汇总见附件一。我们详细分析了排在前四的专业大类的情况
            </p>
          </div>

          <div class="chart_box">
            <h6>2.1.4.1 装备制造大类专业教学资源库建设与应用数据分析</h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
                ProfessionAnalysis.top1Data.bigClass
              }}大类专业教学资源库已立项建设项目共计 {{ ProfessionAnalysis.top1Data.zykCount }} 个，
              已有 {{ ProfessionAnalysis.top1Data.schoolNum }} 所职业院校和
              {{ ProfessionAnalysis.top1Data.companyCount }} 行业企业参与建设；标准课程总量已达{{
                ProfessionAnalysis.top1Data.standardNum
              }}
              门，该专业大类资源总量达 {{ ProfessionAnalysis.top1Data.resourceNum }} 条
              。共有注册用户 {{ ProfessionAnalysis.top1Data.totalUser }}人，按用户身份类型统计，教师
              {{ ProfessionAnalysis.top1Data.userTypeCount.teacher }} 人，学生
              {{ ProfessionAnalysis.top1Data.userTypeCount.student }} 人，企业员工
              {{ ProfessionAnalysis.top1Data.userTypeCount.enterprise }} 人，社会学习者用户
              {{ ProfessionAnalysis.top1Data.userTypeCount.social }} 人， 用户访问资源总量{{
                ProfessionAnalysis.top1Data.resourceVisit
              }}
              次、用户访问课程总量 {{ ProfessionAnalysis.top1Data.courseVisit }}次，用户互动交流次数
              {{ ProfessionAnalysis.top1Data.forumVisit }} 次。
            </p>
            <p>装备制造大类专业教学资源库建设与应用情况具体如下：</p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>专业大类分类</th>
                  <th>汇总</th>
                  <th>资源库名称</th>
                  <th>资源库编码</th>
                  <th>第一主持学校</th>
                  <th>总访问次数</th>
                  <th>总用户数</th>
                  <th>学生数</th>
                  <th>教师数</th>
                  <th>资源总数</th>
                  <th>标准课数</th>
                </tr>

                <tr
                  v-for="(item, index) in ProfessionAnalysis.top1List"
                  :key="index"
                  v-show="ProfessionAnalysis.top1List.length > 0"
                >
                  <!-- <td>{{index+1}}</td> -->
                  <td>{{ item.professionBigClass }}</td>
                  <td>{{ ProfessionAnalysis.top1List.length }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.zyk_num }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.totalVisit }}</td>
                  <td>{{ item.totalUser }}</td>
                  <td>{{ item.student }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.totalResource }}</td>
                  <td>{{ item.standardCourse }}</td>
                </tr>

                <tr v-show="ProfessionAnalysis.top1List.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 530px">
              表3 装备制造大类专业教学资源库建设与应用情况
            </div>
            <p style="margin-top: 20px">
              自{{ nowYear }}年1月1日以来，{{
                ProfessionAnalysis.top1Data.bigClass
              }}资源库新增用户数{{
                ProfessionAnalysis.top1Data.currentYearUserAdd
              }}人，其中新增教师{{ ProfessionAnalysis.top1Data.currentYearTeacherAdd }}人,新增学生{{
                ProfessionAnalysis.top1Data.currentYearStudentAdd
              }}人；新增资源数{{
                ProfessionAnalysis.top1Data.currentYearResourceAdd
              }}个。新增课程数{{
                ProfessionAnalysis.top1Data.currentYearCourseAdd
              }}门。同时，使用次数呈现大幅度上升趋势，累计登录用户{{
                ProfessionAnalysis.top1Data.currentYearActiveUser
              }}
              人，累计点击
              {{ ProfessionAnalysis.top1Data.currentYearVisit }}次。各类型用户日访问走势图如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList1.name"
                :colorList="userAdd.colorList"
                :legendList="['学生']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图26 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日学生访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList2.name"
                :colorList="userAdd.colorList"
                :legendList="['教师']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图27 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日教师访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList3.name"
                :colorList="userAdd.colorList"
                :legendList="['企业用户']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图28 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>

            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList1.dataList4.value"
                :transverseData="ProfessionVisitBar.dataList1.dataList4.name"
                :colorList="userAdd.colorList"
                :legendList="['社会学习者']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图29 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日社会学习者访问情况
            </div>
          </div>

          <div class="chart_box">
            <h6>
              2.1.4.2 {{ ProfessionAnalysis.top2Data.bigClass }}专业教学资源库建设与应用数据分析
            </h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
                ProfessionAnalysis.top2Data.bigClass
              }}大类专业教学资源库已立项建设项目共计 {{ ProfessionAnalysis.top2Data.zykCount }} 个，
              已有 {{ ProfessionAnalysis.top2Data.schoolNum }} 所职业院校和
              {{ ProfessionAnalysis.top2Data.companyCount }} 行业企业参与建设；标准课程总量已达
              {{ ProfessionAnalysis.top2Data.standardNum }} 门 ，该专业大类资源总量达
              {{ ProfessionAnalysis.top2Data.resourceNum }} 条 。注册用户
              {{ ProfessionAnalysis.top2Data.totalUser }} 人，按用户身份类型统计， 教师
              {{ ProfessionAnalysis.top2Data.userTypeCount.teacher }} 人，学生
              {{ ProfessionAnalysis.top2Data.userTypeCount.student }} 人，企业员工
              {{ ProfessionAnalysis.top2Data.userTypeCount.enterprise }} 人，社会学习者用户
              {{ ProfessionAnalysis.top2Data.userTypeCount.social }} 人， 用户访问资源总量
              {{ ProfessionAnalysis.top2Data.resourceVisit }} 次、用户访问课程总量
              {{ ProfessionAnalysis.top2Data.courseVisit }}次，用户互动交流次数
              {{ ProfessionAnalysis.top2Data.forumVisit }}
              次。
            </p>
            <p>电子与信息大类专业教学资源库建设与应用情况具体如下：</p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>专业大类分类</th>
                  <th>汇总</th>
                  <th>资源库名称</th>
                  <th>资源库编码</th>
                  <th>第一主持学校</th>
                  <th>总访问次数</th>
                  <th>总用户数</th>
                  <th>学生数</th>
                  <th>教师数</th>
                  <th>资源总数</th>
                  <th>标准课数</th>
                </tr>

                <tr
                  v-for="(item, index) in ProfessionAnalysis.top2List"
                  :key="index"
                  v-show="ProfessionAnalysis.top2List.length > 0"
                >
                  <td>{{ item.professionBigClass }}</td>
                  <td>{{ ProfessionAnalysis.top2List.length }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.zyk_num }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.totalVisit }}</td>
                  <td>{{ item.totalUser }}</td>
                  <td>{{ item.student }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.totalResource }}</td>
                  <td>{{ item.standardCourse }}</td>
                </tr>

                <tr v-show="ProfessionAnalysis.top2List.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 350px">
              表4 {{ ProfessionAnalysis.top2Data.bigClass }}专业教学资源库建设与应用情况一览表
            </div>
            <p style="margin-top: 20px">
              自{{ nowYear }}年1月1日以来，{{
                ProfessionAnalysis.top2Data.bigClass
              }}资源库新增用户数{{ ProfessionAnalysis.top2Data.currentYearUserAdd }}人，其中新增教师
              {{ ProfessionAnalysis.top2Data.currentYearTeacherAdd }}人,新增学生{{
                ProfessionAnalysis.top2Data.currentYearStudentAdd
              }}人；新增资源数{{
                ProfessionAnalysis.top2Data.currentYearResourceAdd
              }}
              个。新增课程数{{
                ProfessionAnalysis.top2Data.currentYearCourseAdd
              }}
              门。同时，使用次数呈现大幅度上升趋势，累计登录用户
              {{ ProfessionAnalysis.top2Data.currentYearActiveUser }} 人，累计点击
              {{ ProfessionAnalysis.top2Data.currentYearVisit }}万次。各类型用户日访问走势图如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList1.name"
                :colorList="userAdd.colorList"
                :legendList="['学生']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图30 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日学生访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList2.name"
                :colorList="userAdd.colorList"
                :legendList="['教师']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图 31 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日教师访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList3.name"
                :colorList="userAdd.colorList"
                :legendList="['企业用户']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图32 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>

            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList2.dataList4.value"
                :transverseData="ProfessionVisitBar.dataList2.dataList4.name"
                :colorList="userAdd.colorList"
                :legendList="['社会学习者']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图33 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日社会学习者用户访问情况
            </div>
          </div>

          <div class="chart_box">
            <h6>
              2.1.4.3 {{ ProfessionAnalysis.top3Data.bigClass }}专业教学资源库建设与应用数据分析
            </h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
                ProfessionAnalysis.top3Data.bigClass
              }}专业教学资源库已立项建设项目共计 {{ ProfessionAnalysis.top3Data.zykCount }}个， 已有
              {{ ProfessionAnalysis.top3Data.schoolNum }} 所职业院校和
              {{ ProfessionAnalysis.top3Data.companyCount }} 行业企业参与建设；标准课程总量已达
              {{ ProfessionAnalysis.top3Data.standardNum }} ，该专业大类资源总量达
              {{ ProfessionAnalysis.top3Data.resourceNum }} 条 。共有注册用户
              {{ ProfessionAnalysis.top3Data.totalUser }} 人，按用户身份类型统计， 教师
              {{ ProfessionAnalysis.top3Data.userTypeCount.teacher }}人，学生
              {{ ProfessionAnalysis.top3Data.userTypeCount.student }} 人，企业员工
              {{ ProfessionAnalysis.top3Data.userTypeCount.enterprise }} 人，社会学习者用户
              {{ ProfessionAnalysis.top3Data.userTypeCount.social }} 人，整体用户访问资源总量
              {{ ProfessionAnalysis.top3Data.resourceVisit }}次、用户访问课程总量
              {{ ProfessionAnalysis.top3Data.courseVisit }}次，用户互动交流次数
              {{ ProfessionAnalysis.top3Data.forumVisit }} 次。
            </p>
            <p>交通运输大类专业教学资源库建设与应用情况具体如下：</p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>专业大类分类</th>
                  <th>汇总</th>
                  <th style="width: 230px">资源库名称</th>
                  <th>资源库编码</th>
                  <th>第一主持学校</th>
                  <th>总访问次数</th>
                  <th>总用户数</th>
                  <th>学生数</th>
                  <th>教师数</th>
                  <th>资源总数</th>
                  <th>标准课数</th>
                </tr>

                <tr
                  v-for="(item, index) in ProfessionAnalysis.top3List"
                  :key="index"
                  v-show="ProfessionAnalysis.top3List.length > 0"
                >
                  <td>{{ item.professionBigClass }}</td>
                  <td>{{ ProfessionAnalysis.top3List.length }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.zyk_num }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.totalVisit }}</td>
                  <td>{{ item.totalUser }}</td>
                  <td>{{ item.student }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.totalResource }}</td>
                  <td>{{ item.standardCourse }}</td>
                </tr>

                <tr v-show="ProfessionAnalysis.top3List.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 500px">
              表5 {{ ProfessionAnalysis.top3Data.bigClass }}专业教学资源库建设与应用情况一览表
            </div>
            <p style="margin-top: 20px">
              自{{ nowYear }}年1月1日以来，{{
                ProfessionAnalysis.top3Data.bigClass
              }}资源库新增用户数{{ ProfessionAnalysis.top3Data.currentYearUserAdd }}人，其中新增教师
              {{ ProfessionAnalysis.top3Data.currentYearTeacherAdd }}人,新增学生{{
                ProfessionAnalysis.top3Data.currentYearStudentAdd
              }}人；新增资源数{{
                ProfessionAnalysis.top3Data.currentYearResourceAdd
              }}
              个。新增课程数{{
                ProfessionAnalysis.top3Data.currentYearCourseAdd
              }}
              门。同时，使用次数呈现大幅度上升趋势，累计登录用户
              {{ ProfessionAnalysis.top3Data.currentYearActiveUser }} 人，累计点击
              {{ ProfessionAnalysis.top3Data.currentYearVisit }}万次。各类型用户日访问走势图如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList1.name"
                :colorList="userAdd.colorList"
                :legendList="['学生']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图34 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日学生访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList2.name"
                :colorList="userAdd.colorList"
                :legendList="['教师']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图35 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日教师访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList3.name"
                :colorList="userAdd.colorList"
                :legendList="['企业用户']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图36 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>

            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList3.dataList4.value"
                :transverseData="ProfessionVisitBar.dataList3.dataList4.name"
                :colorList="userAdd.colorList"
                :legendList="['社会学习者']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图37 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日社会学习者用户访问情况
            </div>
          </div>

          <div class="chart_box">
            <h6>
              2.1.4.4 {{ ProfessionAnalysis.top4Data.bigClass }}专业教学资源库建设与应用数据分析
            </h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，国家级职业教育{{
                ProfessionAnalysis.top4Data.bigClass
              }}专业教学资源库已立项建设项目共计 {{ ProfessionAnalysis.top4Data.zykCount }} 个，
              已有{{ ProfessionAnalysis.top4Data.schoolNum }} 所职业院校和
              {{ ProfessionAnalysis.top4Data.companyCount }} 行业企业参与建设；标准课程总量已达
              {{ ProfessionAnalysis.top4Data.standardNum }} 门 ，该专业大类资源总量达
              {{ ProfessionAnalysis.top4Data.resourceNum }} 条 。共有注册用户
              {{ ProfessionAnalysis.top4Data.totalUser }} 人，按用户身份类型统计， 教师
              {{ ProfessionAnalysis.top4Data.userTypeCount.teacher }} 人，学生
              {{ ProfessionAnalysis.top4Data.userTypeCount.student }} 人，企业员工
              {{ ProfessionAnalysis.top4Data.userTypeCount.enterprise }} 人，社会学习者用户
              {{ ProfessionAnalysis.top4Data.userTypeCount.social }} 人，整体用户访问资源总量
              {{ ProfessionAnalysis.top4Data.resourceVisit }} 次、用户访问课程总量
              {{ ProfessionAnalysis.top4Data.courseVisit }}次，用户互动交流次数
              {{ ProfessionAnalysis.top4Data.forumVisit }} 次。
            </p>
            <p>财经商贸大类专业教学资源库建设与应用情况具体如下：</p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>专业大类分类</th>
                  <th>汇总</th>
                  <th>资源库名称</th>
                  <th>资源库编码</th>
                  <th>第一主持学校</th>
                  <th>总访问次数</th>
                  <th>总用户数</th>
                  <th>学生数</th>
                  <th>教师数</th>
                  <th>资源总数</th>
                  <th>标准课数</th>
                </tr>

                <tr
                  v-for="(item, index) in ProfessionAnalysis.top4List"
                  :key="index"
                  v-show="ProfessionAnalysis.top4List.length > 0"
                >
                  <td>{{ item.professionBigClass }}</td>
                  <td>{{ ProfessionAnalysis.top4List.length }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.zyk_num }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.totalVisit }}</td>
                  <td>{{ item.totalUser }}</td>
                  <td>{{ item.student }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.totalResource }}</td>
                  <td>{{ item.standardCourse }}</td>
                </tr>

                <tr v-show="ProfessionAnalysis.top4List.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 230px">
              表6 财经商贸大类专业教学资源库建设与应用情况一览表
            </div>
            <p style="margin-top: 20px">
              自{{ nowYear }}年1月1日以来，{{
                ProfessionAnalysis.top4Data.bigClass
              }}资源库新增用户数{{ ProfessionAnalysis.top4Data.currentYearUserAdd }}人，其中新增教师
              {{ ProfessionAnalysis.top4Data.currentYearTeacherAdd }}人,新增学生{{
                ProfessionAnalysis.top4Data.currentYearStudentAdd
              }}人；新增资源数{{
                ProfessionAnalysis.top4Data.currentYearResourceAdd
              }}
              个。新增课程数{{
                ProfessionAnalysis.top4Data.currentYearCourseAdd
              }}
              门。同时，使用次数呈现大幅度上升趋势，累计登录用户
              {{ ProfessionAnalysis.top4Data.currentYearActiveUser }} 人，累计点击
              {{ ProfessionAnalysis.top4Data.currentYearVisit }}万次。各类型用户日访问走势图如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList4.dataList1.value"
                :transverseData="ProfessionVisitBar.dataList4.dataList1.name"
                :colorList="userAdd.colorList"
                :legendList="['学生']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图38 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日学生访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList4.dataList2.value"
                :transverseData="ProfessionVisitBar.dataList4.dataList2.name"
                :colorList="userAdd.colorList"
                :legendList="['教师']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图39 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日教师访问情况
            </div>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList4.dataList3.value"
                :transverseData="ProfessionVisitBar.dataList4.dataList3.name"
                :colorList="userAdd.colorList"
                :legendList="['企业用户']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图40 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日企业用户访问情况
            </div>

            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ProfessionVisitBar.dataList4.dataList4.value"
                :transverseData="ProfessionVisitBar.dataList4.dataList4.name"
                :colorList="userAdd.colorList"
                :legendList="['社会学习者']"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图41 {{ nowYear }}年1月1日至{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日社会学习者访问情况
            </div>
          </div>
        </div>

        <div class="chart_box" style="margin-top: 100px">
          <h5>2.1.5 各省国家级资源库建设与应用情况</h5>
          <div class="chart_box">
            <h6>2.1.5.1 各省国家级资源库建设与应用情况概览</h6>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>序号</th>
                  <th>省份</th>
                  <th>资源库总数</th>
                  <th>素材资源总数</th>
                  <th>标准化课程总数</th>
                  <th>总用户数</th>
                  <th>活跃教师数</th>
                  <th>活跃学生数</th>
                  <th>总访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in getzykTable.dataList"
                  :key="index"
                  v-show="getzykTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province1 }}</td>
                  <td>{{ item.zykCount }}</td>
                  <td>{{ item.resourceCount }}</td>
                  <td>{{ item.courseCount }}</td>
                  <td>{{ item.userCount }}</td>
                  <td>{{ item.teacherCount }}</td>
                  <td>{{ item.studentCount }}</td>
                  <td>{{ item.logNum }}</td>
                </tr>

                <tr v-show="getzykTable.dataList.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 530px">
              表7 各省国家级资源库建设与应用情况概览
            </div>
          </div>
          <div class="chart_box" style="margin-top: 370px">
            <h6>2.1.5.2 各省国家级资源库用户建设与应用情况</h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
                countryLevelUserProvince.userTotal > 10000
                  ? (countryLevelUserProvince.userTotal / 10000).toFixed(2) + "万"
                  : countryLevelUserProvince.userTotal
              }}，覆盖31个省份，其中注册用户最多的是{{
                countryLevelUserProvince.maxUserProvinceInfo.province
              }}省，达{{
                countryLevelUserProvince.maxUserProvinceInfo.maxValue > 10000
                  ? (countryLevelUserProvince.maxUserProvinceInfo.maxValue / 10000).toFixed(2) +
                    "万"
                  : countryLevelUserProvince.maxUserProvinceInfo.maxValue
              }}； 交流互动次数累计{{
                countryLevelUserProvince.formunInfo.total > 100000000
                  ? (countryLevelUserProvince.formunInfo.total / 100000000).toFixed(2) + "亿"
                  : (countryLevelUserProvince.formunInfo.total / 10000).toFixed(2) + "万"
              }}次，互动交流频次最多的是{{ countryLevelUserProvince.formunInfo.province }}省，达{{
                countryLevelUserProvince.formunInfo.maxValue > 10000
                  ? (countryLevelUserProvince.formunInfo.maxValue / 10000).toFixed(2) + "万"
                  : countryLevelUserProvince.formunInfo.maxValue
              }}次；活跃用户总人数{{
                countryLevelUserProvince.activeUserInfo.total > 10000
                  ? (countryLevelUserProvince.activeUserInfo.total / 10000).toFixed(2) + "万"
                  : ccountryLevelUserProvince.activeUserInfo.total
              }}，活跃用户数最多的是{{ countryLevelUserProvince.activeUserInfo.province }}省，共{{
                countryLevelUserProvince.activeUserInfo.maxValue > 10000
                  ? (countryLevelUserProvince.activeUserInfo.maxValue / 10000).toFixed(2) + "万"
                  : countryLevelUserProvince.activeUserInfo.maxValue
              }}人。 具体各省资源库用户按照活跃用户数排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源库数 (个)</th>
                  <th>注册用户数 (个)</th>
                  <th>交流互动量 (次)</th>
                  <th>活跃用户数 (人)</th>
                </tr>

                <tr
                  v-for="(item, index) in countryLevelUserProvince.dataList"
                  :key="index"
                  v-show="countryLevelUserProvince.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.zykCount }}</td>
                  <td>{{ item.num }}</td>
                  <td>{{ item.formun }}</td>
                  <td>{{ item.activeNum }}</td>
                </tr>

                <tr v-show="countryLevelUserProvince.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 20px">
              表8 各省国家级资源库活跃用户数排名（前十五名）
            </div>
            <div class="chart_box">
              <div class="standards_content echartsHeight" style="height: 1000px">
                <distributionChart
                  :refId="'userTalk'"
                  :datas="userProvince.mapdatas"
                  :color="userProvince.mapcolorList"
                  :isExportFont="18"
                  :zoom="true"
                ></distributionChart>
              </div>
              <div class="chart_name">图42 各省访问热力图</div>
            </div>
          </div>

          <div class="chart_box">
            <h6>2.1.5.3 各省国家级资源库课程建设及应用情况</h6>
            <div class="chart_box">
              <p>
                截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设课程总计{{
                  getUtils_Fun(countryCourseCountProvinceRank_obj.zykCourseBuildCountNum)
                }}门，覆盖31个省份，其中建设课程数量最多的是{{
                  countryCourseCountProvinceRank_obj.zykCourseMaxProvince.name
                }}，有{{
                  getUtils_Fun(countryCourseCountProvinceRank_obj.zykCourseMaxProvince.value)
                }}门；标准课程数累计有{{
                  countryCourseCountProvinceRank_obj.snum
                }}门，标准化课程数最多的是{{
                  countryCourseCountProvinceRank_obj.countryCourseStandardCountMax.name
                }}，共{{
                  countryCourseCountProvinceRank_obj.countryCourseStandardCountMax.value
                }}门；个性化课程数累计有{{
                  getUtils_Fun(countryCourseCountProvinceRank_obj.pnum)
                }}门，个性化课程数最多的{{
                  countryCourseCountProvinceRank_obj.countryCoursePersonalityCountMax.name
                }}有{{
                  countryCourseCountProvinceRank_obj.countryCoursePersonalityCountMax.value
                }}门。 具体各省按照总课程数排名（前十五名）如下表所示：
              </p>
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>标准化课程数 (个)</th>
                    <th>个性化课程数</th>
                    <th>总课程数 (门)</th>
                  </tr>

                  <tr
                    v-for="(
                      item, index
                    ) in countryCourseCountProvinceRank_obj.countryCourseCountProvinceRank"
                    :key="index"
                    v-show="
                      countryCourseCountProvinceRank_obj.countryCourseCountProvinceRank.length > 0
                    "
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.snum }}</td>
                    <td>{{ item.pnum }}</td>
                    <td>{{ item.num }}</td>
                  </tr>

                  <tr
                    v-show="
                      countryCourseCountProvinceRank_obj.countryCourseCountProvinceRank.length == 0
                    "
                    class="nothing"
                  >
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表9 各省国家级资源库总课程数排名（前十五名）</div>
            </div>
          </div>
        </div>
      </div>
      <div class="chart_box" style="margin-top: 900px">
        <h4>2.1.5.4 各省国家级资源库资源建设及应用情况</h4>
        <div class="chart_box">
          <div class="chart_box">
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设资源累计达{{
                getUtils_Fun(getCountryProvinceZykBuild.zykBuildResourceCount)
              }}条，覆盖31个省份， 其中建设资源数量最多的是{{
                getCountryProvinceZykBuild.zykNumMaxProvince.province
              }}，有{{
                getUtils_Fun(getCountryProvinceZykBuild.zykNumMaxProvince.num)
              }}条。各省访问资源的总量达{{
                getUtils_Fun(getCountryProvinceZykBuild.countryResourceTotalLog)
              }}次，访问资源总量最多的是{{
                getCountryProvinceZykBuild.resourceVisitMaxProvince
              }}省。具体各省资源库资源建设按照访问量情况排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源数 (条)</th>
                  <th>资源量（TB）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(
                    item, index
                  ) in getCountryProvinceZykBuild.countryResourceProvinceStateRank"
                  :key="index"
                  v-show="getCountryProvinceZykBuild.countryResourceProvinceStateRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.log }}</td>
                  <td>{{ item.disksNum }}</td>
                  <td>{{ item.count }}</td>
                </tr>

                <tr
                  v-show="getCountryProvinceZykBuild.countryResourceProvinceStateRank.length == 0"
                  class="nothing"
                >
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表10 各省国家级资源库资源访问量情况排名（前十五名）</div>
          </div>
          <!-- <div class="chart_box">
            <div
              class="standards_content echartsHeight"
              style="height: 1000px;"
            >
              <distributionChart
                :refId="'userTalk'"
                :datas="userProvince.mapdatas"
                :color="userProvince.mapcolorList"
                :isExportFont="18"
                :zoom="true"
              ></distributionChart>
            </div>
            <div class="chart_name">图 29 各省用户访问资源库分布</div>
          </div> -->
        </div>
        <div class="chart_box" style="margin-top: 400px">
          <h5>2.1.6 203个国家级资源库 {{ nowYear }}年建设与应用情况</h5>
          <h6>2.1.6.1 国家级资源库 {{ nowYear }}年用户新增情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年学生新增共{{ ZykStudentUser.secondTotal }}个，较 {{ nowYear - 1 }}年{{
                getReduceOrAdd(ZykStudentUser.secondTotal - ZykStudentUser.firstTotal)
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykStudentUser.dataList"
                :transverseData="ZykStudentUser.studentSecondTimeDay"
                :colorList="userAdd.colorList"
                :innerText="'单位：人'"
                :isaverage="true"
                :legendList="[nowYear, (nowYear - 1).toString()]"
              ></discountChart>
            </div>
            <div class="chart_name">
              图43 {{ nowYear }}年学生新增情况及与{{ nowYear - 1 }}年对比分析
            </div>
          </div>
          <div class="chart_box">
            <p>
              {{ nowYear }}年教师新增共{{ ZykTeacherUser.secondTotal }}个，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(ZykTeacherUser.secondTotal - ZykTeacherUser.firstTotal)
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykTeacherUser.dataList"
                :transverseData="ZykTeacherUser.secondTimeTeacherDay"
                :colorList="userAdd.colorList"
                :innerText="'单位：人'"
                :isaverage="true"
                :legendList="[nowYear, (nowYear - 1).toString()]"
              ></discountChart>
            </div>
            <div class="chart_name">
              图44 {{ nowYear }}年教师新增情况及与{{ nowYear - 1 }}年对比分析
            </div>
          </div>
          <div class="chart_box">
            <p>
              {{ nowYear }}年社会学习者新增共{{ countryZyk.secondTotal }}个，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(countryZyk.secondTotal - countryZyk.firstTotal)
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="countryZyk.dataList"
                :transverseData="countryZyk.secondTimeSocietyDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图45 {{ nowYear }}年社会学习者新增情况及与{{ nowYear - 1 }}年对比分析
            </div>
          </div>
          <div class="chart_box">
            <p>
              {{ nowYear }}年企业用户新增共{{ ZykEnterpriseUser.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(ZykEnterpriseUser.secondTotal - ZykEnterpriseUser.firstTotal)
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykEnterpriseUser.dataList"
                :transverseData="ZykEnterpriseUser.secondTimeEnterpriseDay"
                :colorList="userAdd.colorList"
                :innerText="'单位：人'"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图46 {{ nowYear }}年企业用户新增情况及与{{ nowYear - 1 }}年对比分析
            </div>
          </div>
          <h6>2.1.6.2 国家级资源库{{ nowYear }}年资源新增情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年素材资源新增共{{ ZykResourceNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  ZykResourceNewAddCase.secondTotal - ZykResourceNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykResourceNewAddCase.dataList"
                :transverseData="ZykResourceNewAddCase.secondTimeResourceDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图47 {{ nowYear }}年素材资源新增情况及与{{ nowYear - 1 }}年对比分析
            </div>
          </div>
          <h6>2.1.6.3 国家级资源库{{ nowYear }}年课程新增情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年课程新增共{{ ZykCourseNewAddCase.secondTotal }}门，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(ZykCourseNewAddCase.secondTotal - ZykCourseNewAddCase.firstTotal)
              }}个
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykCourseNewAddCase.dataList"
                :transverseData="ZykCourseNewAddCase.secondTimeCourseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图48</div>
          </div>

          <h6>2.1.6.4 国家级资源库{{ nowYear }}年用户访问情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年资源库累计登录用户
              {{ formatPersonNum(ZykStudentUserVisitCase.totalLoginUserNum) }}人，累计点击
              {{ getUtils_Fun(countryZykTotalVisit) }}次。各类型用户日访问走势图如下：
            </p>
            <p>
              学生用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(ZykStudentUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  ZykStudentUserVisitCase.secondTotal - ZykStudentUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykStudentUserVisitCase.dataList"
                :transverseData="ZykStudentUserVisitCase.secondTimeStudentDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              教师用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(ZykTeacherUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  ZykTeacherUserVisitCase.secondTotal - ZykTeacherUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykTeacherUserVisitCase.dataList"
                :transverseData="ZykTeacherUserVisitCase.secondTimeTeacherDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              企业用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(ZykEnterpriseUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  ZykEnterpriseUserVisitCase.secondTotal - ZykEnterpriseUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykEnterpriseUserVisitCase.dataList"
                :transverseData="ZykEnterpriseUserVisitCase.secondTimeEnterpriseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              社会学习者{{ nowYear }}年访问资源库共{{
                getUtils_Fun(ZykSocietyUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  ZykSocietyUserVisitCase.secondTotal - ZykSocietyUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykSocietyUserVisitCase.dataList"
                :transverseData="ZykSocietyUserVisitCase.secondTimeSocietyDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>

            <div class="chart_name">图49 各类型用户日访问走势图</div>
          </div>

          <h6>2.1.6.5 国家级资源库{{ nowYear }}年课程访问情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年资源库课程访问共{{
                getUtils_Fun(ZykCourseVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(ZykCourseVisitCase.secondTotal - ZykCourseVisitCase.firstTotal)
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykCourseVisitCase.dataList"
                :transverseData="ZykCourseVisitCase.secondTimeCourseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图50 {{ nowYear }}年课程访问情况及与{{ nowYear - 1 }}年对比
            </div>
          </div>
          <h6>2.1.6.6 国家级资源库{{ nowYear }}年资源访问情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年资源库资源访问共{{
                getUtils_Fun(ZykResourceVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(ZykResourceVisitCase.secondTotal - ZykResourceVisitCase.firstTotal)
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykResourceVisitCase.dataList"
                :transverseData="ZykResourceVisitCase.secondTimeResourceDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">
              图51 {{ nowYear }}年资源访问情况及与{{ nowYear - 1 }}年对比
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h5>2.1.7 203个资源库年度排名分析</h5>
          <h6>2.1.7.1 按资源量维度排名</h6>

          <div class="chart_box">
            <p>
              203 个资源库项目中，{{
                sourceMater2171.legendList[0]
              }}资源库的资源数量最多，紧随其后的是{{ sourceMater2171.legendList[1] }}资源库和{{
                sourceMater2171.legendList[2]
              }}资源库。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="sourceMater2171.dataList"
                :transverseData="sourceMater2171.legendList"
                :colorList="sourceMater.colorList"
                style="height: 150%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 200px">
              图52 国家级资源库资源数排名情况（前十五名）
            </div>
          </div>

          <div class="chart_box">
            <h6>2.1.7.2 按访问量维度排名</h6>
            <p>
              203个资源库项目中，{{
                sourceMater2172.legendList[0]
              }}资源库的访问量最多，紧随其后的是{{ sourceMater2172.legendList[1] }}和{{
                sourceMater2172.legendList[2]
              }}。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="sourceMater2172.dataList"
                :transverseData="sourceMater2172.legendList"
                :colorList="sourceMater.colorList"
                :gridY="'4%'"
                style="height: 150%"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 200px">
              图53 国家级资源库访问量排名情况（前十五名）
            </div>
          </div>

          <div class="chart_box">
            <h6>2.1.7.3 按库内活跃用户数维度排名</h6>
            <p>
              203 个资源库项目中，{{
                sourceMater2173.legendList[0]
              }}资源库的活跃用户数最多，紧跟其后的是{{ sourceMater2173.legendList[1] }}资源库和{{
                sourceMater2173.legendList[2]
              }}资源库。
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="sourceMater2173.dataList"
                :transverseData="sourceMater2173.legendList"
                :colorList="sourceMater.colorList"
                style="height: 150%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 200px">
              图 54 国家级资源库活跃用户排名情况（前十五名）
            </div>
          </div>

          <div class="chart_box">
            <h6>2.1.7.4 {{ nowYear }}年综合应用排行排名</h6>
            <p>
              根据国家资源库{{
                nowYear
              }}年建设与应用情况，取全年访问量、建设单位中已实名但无活动的用户数、无活动资源数等多项指标进行综合排名，排前十五名和后十五名的资源库如下表所示，全部排名情况见附件。
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>序号</th>
                  <th>项目编号</th>
                  <th>资源库名称</th>
                  <th>第一主持单位</th>
                </tr>

                <tr
                  v-for="(item, index) in disksNum_top"
                  :key="index"
                  v-show="disksNum_top.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zykNum }}</td>
                  <td>{{ item.zykName }}</td>
                  <td>{{ item.firstChargeUnit }}</td>
                </tr>

                <tr v-show="disksNum_top.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 50px">
              表11 203个国家级专业教学资源库{{ nowYear }}年综合应用排名（前十五名）
            </div>
            <div class="biaoge" style="margin-top: 50px">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>序号</th>
                  <th>项目编号</th>
                  <th>资源库名称</th>
                  <th>第一主持单位</th>
                </tr>

                <tr
                  v-for="(item, index) in disksNum_last"
                  :key="index"
                  v-show="disksNum_last.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zykNum }}</td>
                  <td>{{ item.zykName }}</td>
                  <td>{{ item.firstChargeUnit }}</td>
                </tr>

                <tr v-show="disksNum_last.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 50px">
              表12 203个国家级专业教学资源库{{ nowYear }}年综合应用排名（后十五名）
            </div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h4>2.2 国家及省市校级专业教学资源库运行监测情况分析</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，职业教育专业教学资源库已纳入监测项目共计{{
            runCase.zykLevelsCount.dataList[0]
          }}个，其中国家级资源库共计{{ runCase.zykLevelsCount.dataList[1] }}个，省级资源库共计{{
            runCase.zykLevelsCount.dataList[2]
          }}个，校级资源库共计{{ runCase.zykLevelsCount.dataList[3] }}个，覆盖了{{
            runCase.professionCategoryNum.length - 1
          }}个专业大类。目前，已有{{ runCase.schoolBuildNum }}所职业院校和{{
            runCase.companyBuildNum
          }}家行业企业参与建设，标准化课程总量已达{{
            getUtils_Fun(runCase.standardNum)
          }}门，资源总量达{{ getUtils_Fun(runCase.resourceNum) }}余条，共有注册用户{{
            getUtils_Fun(runCase.totalUserCount)
          }}余人，总访问量{{
            getUtils_Fun(runCase.totalVisitNum)
          }}次，形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设与应用情况分析如下：
        </p>
        <div class="chart_box">
          <h5>2.2.1 用户建设及应用</h5>
          <div class="chart_box">
            <p>
              当前，资源库共有注册用户{{
                getUtils_Fun(analysis.totalUserCount)
              }}余人，按用户身份类型统计，教师{{ getUtils_Fun(analysis.teacher) }}余人，学生{{
                getUtils_Fun(analysis.student)
              }}余人。资源库企业用户{{ getUtils_Fun(analysis.enterprise) }}余人
              ，能够较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者用户{{
                getUtils_Fun(analysis.social)
              }}余人，努力承担面向普通劳动者免费线上培训的社会责任。资源库项目整体用户访问资源总量约{{
                getUtils_Fun(analysis.resourceModule)
              }}次、用户访问课程总量约{{
                getUtils_Fun(analysis.courseModule)
              }}次，用户互动交流次数约{{ getUtils_Fun(analysis.userModule) }}次。
            </p>
            <p>用户类型分布详情如下所示：</p>
            <div class="standards_content echartsHeight">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="analysis.userMap"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 57 用户整体情况</div>
            <div class="standards_content echartsHeight">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="analysis.studentType"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图58 学生类型分布情况</div>
          </div>
          <div class="chart_box">
            <h4>2.2.2 课程建设及应用</h4>
            <p>
              当前，资源库项目课程总量达到{{
                getUtils_Fun(courseBuild.courseNum)
              }}门，其中个性化课程{{
                getUtils_Fun(courseBuild.courseType.value[1])
              }}门，标准化课程{{
                getUtils_Fun(courseBuild.courseType.value[0])
              }}门。课程访问日均次数{{
                courseBuild.CourseDayVisitNum
              }}次，其中，注册学生用户访问最多的课程是《{{
                courseBuild.courseMaxCount.name
              }}》,属于“{{ courseBuild.courseMaxCount.zykName }}资源库”。在{{
                courseBuild.courseMaxCount.zykDiv
              }}%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="courseBuild.courseType.value"
                :transverseData="courseBuild.courseType.name"
                :colorList="getcourse.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图59课程整体情况</div>
          </div>
        </div>

        <div class="chart_box">
          <h5>2.2.3 资源建设及应用</h5>
          <div class="chart_box">
            <p>
              资源库项目资源数量达余条，资源总容量达{{
                formatValue(getResource.resourceCapacityNum / 1024 / 1024)
              }}TB,视频类资源数量最多，达到{{
                getUtils_Fun(getResource.resourceTypeMap.value[0])
              }}条。除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
                getUtils_Fun(getResource.resourceTypeMap.value[3])
              }}条虚拟仿真资源。资源访问总量已达{{
                getUtils_Fun(getResource.resourceTotal)
              }}余次，日均访问资源{{ getResource.resourceAvg }}次；其中访问次数最多的资源是“{{
                getResource.visitMaxResource.name
              }}”,属于“{{ getResource.visitMaxResource.zykName }}资源库”。
            </p>
            <p>资源按类型分布详情如下：</p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="getResource.resourceTypeMap.value"
                :transverseData="getResource.resourceTypeMap.name"
                :colorList="sourceMater.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 250px">图60资源整体情况</div>
          </div>

          <div class="chart_box">
            <h5>2.2.4 各省资源库建设与应用情况</h5>
            <h6>2.2.4.1 各省资源库建设与应用情况概览</h6>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>序号</th>
                  <th>省份</th>
                  <th>资源库总数</th>
                  <th>素材资源总数</th>
                  <th>标准化课程总数</th>
                  <th>总用户数</th>
                  <th>活跃教师数</th>
                  <th>活跃学生数</th>
                  <th>总访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in getProvince.zykProvinceClassify"
                  :key="index"
                  v-show="getProvince.zykProvinceClassify.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province1 }}</td>
                  <td>{{ item.zykCount }}</td>
                  <td>{{ item.resourceCount }}</td>
                  <td>{{ item.courseCount }}</td>
                  <td>{{ item.userCount }}</td>
                  <td>{{ item.teacherCount }}</td>
                  <td>{{ item.studentCount }}</td>
                  <td>{{ item.logNum }}</td>
                </tr>

                <tr v-show="getProvince.zykProvinceClassify.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
                <tr></tr>
              </table>
            </div>
            <div class="chart_name">表16 各省资源库建设与应用情况概览</div>
          </div>

          <div class="chart_box">
            <h6>2.2.4.2 各省用户建设与应用情况</h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，注册用户总计{{
                getUtils_Fun(getProvinceUser.zykUserNum)
              }}，覆盖31个省份，其中注册用户最多的是{{
                getProvinceUser.maxRegisteredUsersProvince.province
              }}省，达{{ getUtils_Fun(getProvinceUser.maxRegisteredUsersProvince.num) }}；
              交流互动次数累计{{
                getUtils_Fun(getProvinceUser.forumLogProvinceNumTotal)
              }}次，互动交流频次最多的是{{
                getProvinceUser.maxInteractiveUsersProvince.province
              }}省，达{{
                getUtils_Fun(getProvinceUser.maxInteractiveUsersProvince.num)
              }}次；活跃用户总人数{{
                getUtils_Fun(getProvinceUser.provinceStatusActiveUserTotal)
              }}，活跃用户数最多的是{{ getProvinceUser.provinceStatusActiveUser.province }}省，共{{
                getUtils_Fun(getProvinceUser.provinceStatusActiveUser.activeNum)
              }}人。 具体各省资源库用户按照活跃用户数排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源库数（个）</th>
                  <th>注册用户数（个）</th>
                  <th>在线学习数（人）</th>
                  <th>交流互动量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in getProvinceUser.provinceStatusActiveUserRank"
                  :key="index"
                  v-show="getProvinceUser.provinceStatusActiveUserRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province }}</td>
                  <td>{{ item.zykCount }}</td>
                  <td>{{ item.num }}</td>
                  <td>{{ item.activeNum }}</td>
                  <td>{{ item.formun }}</td>
                </tr>

                <tr
                  v-show="getProvinceUser.provinceStatusActiveUserRank.length == 0"
                  class="nothing"
                >
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表17 资源库中各省份在线学习人数排名（前十五名）</div>

            <div class="standards_content echartsHeight" style="height: 1000px">
              <distributionChart
                :refId="'userTalk'"
                :datas="getProvinceUser.provinceLogTotal"
                :color="userProvince.mapcolorList"
                :isExportFont="18"
                :zoom="true"
              ></distributionChart>
            </div>
            <div class="chart_name">图61 各省访问热力图</div>
          </div>

          <div class="chart_box">
            <h6>2.2.4.3 各省课程建设及应用情况</h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设课程总计{{
                getUtils_Fun(CourseBuildAndAnalysis.zykBuildCourseCount)
              }}门，覆盖31个省份，其中建设课程数量最多的是{{
                CourseBuildAndAnalysis.courseRank[0].name
              }}，有{{
                getUtils_Fun(CourseBuildAndAnalysis.courseRank[0].num)
              }}门；标准化课程数累计有{{
                getUtils_Fun(CourseBuildAndAnalysis.standardIntValue)
              }}门， 标准化课程数最多的是{{ CourseBuildAndAnalysis.standard.name }}，共{{
                CourseBuildAndAnalysis.standard.value
              }}门，个性化课程数累计有{{
                getUtils_Fun(CourseBuildAndAnalysis.personalizationIntlValue)
              }}门，个性化课程数最多的{{ CourseBuildAndAnalysis.personality.name }}有{{
                getUtils_Fun(CourseBuildAndAnalysis.personality.value)
              }}门。 具体各省按照总课程数排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>标准化课程数</th>
                  <th>个性化课程数</th>
                  <th>总课程数</th>
                </tr>

                <tr
                  v-for="(item, index) in CourseBuildAndAnalysis.courseRank"
                  :key="index"
                  v-show="CourseBuildAndAnalysis.courseRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.snum }}</td>
                  <td>{{ item.pnum }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="CourseBuildAndAnalysis.courseRank.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表18 各省资源库总课程数排名（前十五名）</div>
          </div>

          <div class="chart_box">
            <h6>2.2.4.4 各省资源建设及应用情况</h6>
            <p>
              截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，资源库建设资源累计达{{
                getUtils_Fun(ZyBuildAndAnalysis.resourceBuildCount)
              }}条，覆盖31个省份， 其中建设资源数量最多的是{{
                ZyBuildAndAnalysis.resourceBuildProvinceMax.province
              }}省，有{{
                ZyBuildAndAnalysis.resourceBuildProvinceMax.num
              }}条。各省访问资源的总量达{{
                getUtils_Fun(ZyBuildAndAnalysis.resourceTotal)
              }}次，访问资源总量最多的是{{
                ZyBuildAndAnalysis.resourceProvinceVisitMax.province
              }}省。具体各省资源库资源建设按照资源数情况排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源数（条）</th>
                  <th>资源量（TB）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in ZyBuildAndAnalysis.resourceProvinceStateRank"
                  :key="index"
                  v-show="ZyBuildAndAnalysis.resourceProvinceStateRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province1 }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.disksNum }}</td>
                  <td>{{ item.log }}</td>
                </tr>

                <tr
                  v-show="ZyBuildAndAnalysis.resourceProvinceStateRank.length == 0"
                  class="nothing"
                >
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 19 各省资源库资源数情况排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box">
          <h5>2.2.5 {{ nowYear }}年总体建设与应用情况</h5>
          <h6>2.2.5.1 资源库用户新增情况</h6>
          <div class="chart_box">
            <p>
              {{ nowYear }}年学生新增共{{ ZykStudentUserNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  ZykStudentUserNewAddCase.secondTotal - ZykStudentUserNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykStudentUserNewAddCase.dataList"
                :transverseData="ZykStudentUserNewAddCase.studentSecondTimeDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图62 资源库学生新增情况及与{{ nowYear - 1 }}年对比</div>
            <p>
              {{ nowYear }}年教师新增共{{ ZykTeacherUserNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  ZykTeacherUserNewAddCase.secondTotal - ZykTeacherUserNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykTeacherUserNewAddCase.dataList"
                :transverseData="ZykTeacherUserNewAddCase.secondTimeTeacherDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图63 资源库教师新增情况及与{{ nowYear - 1 }}年对比</div>
            <p>
              {{ nowYear }}年社会学习者新增共{{ ZykSocietyUserNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  ZykSocietyUserNewAddCase.secondTotal - ZykSocietyUserNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykSocietyUserNewAddCase.dataList"
                :transverseData="ZykSocietyUserNewAddCase.secondTimeSocietyDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图64 资源库社会学习者新增情况及与{{ nowYear }}年对比</div>
            <p>
              {{ nowYear }}年企业用户新增共{{ ZykEnterpriseUserNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  ZykEnterpriseUserNewAddCase.secondTotal - ZykEnterpriseUserNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="ZykEnterpriseUserNewAddCase.dataList"
                :transverseData="ZykEnterpriseUserNewAddCase.secondTimeEnterpriseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图65 资源库企业用户新增情况及与{{ nowYear - 1 }}年对比</div>
          </div>

          <div class="chart_box">
            <h6>2.2.5.2 资源库资源新增情况</h6>
            <p>
              {{ nowYear }}年素材资源新增共{{ getZykResourceNewAddCase.secondTotal }}个，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  getZykResourceNewAddCase.secondTotal - getZykResourceNewAddCase.firstTotal
                )
              }}个。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykResourceNewAddCase.dataList"
                :transverseData="getZykResourceNewAddCase.secondTimeResourceDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图66 资源库素材资源新增情况及与{{ nowYear - 1 }}年对比</div>
          </div>

          <div class="chart_box">
            <h6>2.2.5.3 资源库课程新增情况</h6>
            <p>
              {{ nowYear }}年课程新增共{{ getZykCourseNewAddCase.secondTotal }}门，较{{
                nowYear - 1
              }}年{{
                getReduceOrAdd(
                  getZykCourseNewAddCase.secondTotal - getZykCourseNewAddCase.firstTotal
                )
              }}门。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykCourseNewAddCase.dataList"
                :transverseData="getZykCourseNewAddCase.secondTimeCourseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图67 资源库课程新增情况及与{{ nowYear - 1 }}年对比</div>
          </div>

          <div class="chart_box">
            <h6>2.2.5.4 资源库用户访问情况</h6>
            <p>
              {{ nowYear }}年资源库累计登录用户{{
                formatPersonNum(allLevelTotalLoginUser)
              }}人，累计点击 {{ formatPersonNum(zykTotalVisit) }}次。各类型用户日访问走势图如下：
            </p>
            <p>
              学生用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(getZykStudentUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykCourseNewAddCase.secondTotal - getZykStudentUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykStudentUserVisitCase.dataList"
                :transverseData="getZykStudentUserVisitCase.secondTimeStudentDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              教师用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(getZykTeacherUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykTeacherUserVisitCase.secondTotal - getZykTeacherUserVisitCase.firstTotal
                )
              }}次次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykTeacherUserVisitCase.dataList"
                :transverseData="getZykTeacherUserVisitCase.secondTimeTeacherDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              企业用户{{ nowYear }}年访问资源库共{{
                getUtils_Fun(getZykEnterpriseUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykEnterpriseUserVisitCase.secondTotal -
                    getZykEnterpriseUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykEnterpriseUserVisitCase.dataList"
                :transverseData="getZykEnterpriseUserVisitCase.secondTimeEnterpriseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <p>
              社会学习者{{ nowYear }}年访问资源库共{{
                getUtils_Fun(getZykSocietyUserVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykSocietyUserVisitCase.secondTotal - getZykSocietyUserVisitCase.firstTotal
                )
              }}次
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykSocietyUserVisitCase.dataList"
                :transverseData="getZykSocietyUserVisitCase.secondTimeSocietyDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图68 资源库各类型用户访问情况及与{{ nowYear - 1 }}年对比</div>
          </div>

          <div class="chart_box">
            <h6>2.2.5.5 资源库课程访问情况</h6>
            <p>
              {{ nowYear }}年资源库课程访问共{{
                getUtils_Fun(getZykCourseVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykCourseVisitCase.secondTotal - getZykCourseVisitCase.firstTotal
                )
              }}次。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykCourseVisitCase.dataList"
                :transverseData="getZykCourseVisitCase.secondTimeCourseDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图69资源库课程访问情况及与{{ nowYear - 1 }}年对比</div>
          </div>

          <div class="chart_box">
            <h6>2.2.5.6 资源库资源访问情况</h6>
            <p>
              {{ nowYear }}年资源库资源访问共{{
                getUtils_Fun(getZykResourceVisitCase.secondTotal)
              }}次，较{{ nowYear - 1 }}年{{
                getReduceOrAdd(
                  getZykResourceVisitCase.secondTotal - getZykResourceVisitCase.firstTotal
                )
              }}次。
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :isExportTextColor="true"
                :isShowTextColor="true"
                :refId="'visitsMonthChart'"
                :datas="getZykResourceVisitCase.dataList"
                :transverseData="getZykResourceVisitCase.secondTimeResourceDay"
                :colorList="userAdd.colorList"
                :legendList="[nowYear, (nowYear - 1).toString()]"
                :innerText="'单位：人'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图70 资源库资源访问情况及与{{ nowYear - 1 }}年对比</div>
          </div>
        </div>
      </div>

      <div class="chart_box" style="margin-top: 400px">
        <div class="chart_box">
          <h5>2.2.6 资源库建设与应用情况排名</h5>
          <h6>2.2.6.1 资源量排名</h6>
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="ZykActiveResourceRank.value"
                :transverseData="ZykActiveResourceRank.name"
                :colorList="getUser.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 250px">图71 资源量排名（前十五名）</div>
          </div>
          <h6>2.2.6.2 访问量排名</h6>
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="ZykBuildAnalysisLogRank.value"
                :transverseData="ZykBuildAnalysisLogRank.name"
                :colorList="getUser.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 250px">图72 访问量排名（前十五名）</div>
          </div>

          <h6>2.2.6.3 活跃用户数排名</h6>
          <div class="chart_box">
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'coursesOfferedChart'"
                :isExportTextColor="true"
                :isShowTextColor="true"
                :datas="ZykActiveUserRank.value"
                :transverseData="ZykActiveUserRank.name"
                :colorList="getUser.colorList"
                style="height: 160%"
                :gridY="'4%'"
              ></tcolumnarChart>
            </div>
            <div class="chart_name" style="margin-top: 250px">图73 活跃用户数排名（前十五名）</div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h3>3 职业教育在线精品课程运行监测分析</h3>
        <h4>3.1 {{ nowYear }}年度运行监测总体情况</h4>
        <p>
          截止到{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，在线精品课程共纳入监测{{
            CourseYearRunAnalysis.onlineCourseNum
          }}门，其中，{{ CourseYearRunAnalysis.onlineCourseLevelNums[1].kname }}课程有{{
            CourseYearRunAnalysis.onlineCourseLevelNums[1].num
          }}门，{{ CourseYearRunAnalysis.onlineCourseLevelNums[0].kname }}课程有{{
            CourseYearRunAnalysis.onlineCourseLevelNums[0].num
          }}门，{{ CourseYearRunAnalysis.onlineCourseLevelNums[2].kname }}课程有{{
            CourseYearRunAnalysis.onlineCourseLevelNums[2].num
          }}门。目前，在线精品课程已有{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[7]
          }}所院校和{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[5]
          }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[6])
          }}次，总开课期数为{{
            CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[0]
          }}期，总课时数为{{
            getUtils_Fun(CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[2])
          }}小时，总选课人数{{
            getUtils_Fun(CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[4])
          }}人，总互动次数{{
            getUtils_Fun(CourseYearRunAnalysis.OnlineCourseCoreIndicatorStat.value[1])
          }}次。如图所示：
        </p>
        <p>具体建设与应用情况分析如下：</p>
        <div class="chart_box">
          <h5>3.1.1 课程建设数据</h5>
          <h6>3.1.1.1 各省参建课程数量</h6>
          <p>
            截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
              ProvinceBuildCourseNum[0].name
            }}省参与建设课程数量最多，共{{
              ProvinceBuildCourseNum[0].value
            }}门，具体各省参建课程数量分布如图所示：
          </p>
          <div class="chart_box">
            <div class="standards_content echartsHeight" style="width: 1700px">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="ProvinceBuildCourseNum"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'50%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name" style="margin-top: 160px">图75 各省参建课程数量</div>
          </div>

          <h6>3.1.1.2 归属专业大类分布情况</h6>
          <p>
            截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程覆盖{{
              BigClassCourseNum.dataList.length - 1
            }}个专业大类。从专业大类分布看，{{
              BigClassCourseNum.dataList[0].name
            }}的课程最多，一共{{ BigClassCourseNum.dataList[0].value }}门课程，占比达{{
              ((BigClassCourseNum.dataList[0].value / BigClassCourseNum.total) * 100).toFixed(2)
            }}%，具体在线精品课分布如图所示：
          </p>
          <div class="chart_box">
            <div class="standards_content echartsHeight" style="width: 1700px">
              <circularChart
                :isShowTextColor="true"
                :refId="'typeDistributionChart'"
                :datas="BigClassCourseNum.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'50%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name" style="margin-top: 160px">图76 归属专业大类分布情况</div>
          </div>
        </div>

        <div class="chart_box">
          <h5>3.1.2 在线精品课访问数据</h5>
          <div class="chart_box">
            <p>
              截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计访问量{{
                getUtils_Fun(OnlineCourseVisitNum.onlineCourseTotalVisit)
              }}，访问量最高的课程是{{
                OnlineCourseVisitNum.onlineCourseVisitRank[0].schoolname
              }}的《{{
                OnlineCourseVisitNum.onlineCourseVisitRank[0].name
              }}》，访问量排名（前十五名）的课程信息如表20所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th style="width: 400px">课程</th>
                  <th>课程负责人</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in OnlineCourseVisitNum.onlineCourseVisitRank"
                  :key="index"
                  v-show="OnlineCourseVisitNum.onlineCourseVisitRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.teacher }}</td>
                  <td>{{ item.schoolname }}</td>
                  <td>{{ item.level }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="OnlineCourseVisitNum.onlineCourseVisitRank.length == 0" class="nothing">
                  <td colspan="7">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name" style="margin-top: 120px">表20 访问量排名（前十五名）</div>

            <h5 style="margin-top: 50px">3.1.3 在线精品课开课数据</h5>
            <div class="chart_box">
              <p>
                截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计开课期数{{
                  OnlineCourseOpenNum.onlineCourseTotalOpenNum
                }}期，开课期数最多的课程是{{
                  OnlineCourseOpenNum.onlineCourseOpenRank[0].schoolname
                }}的《{{
                  OnlineCourseOpenNum.onlineCourseOpenRank[0].name
                }}》，开课期数（前十五名）的课程信息如表21所示：
              </p>
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>开课期数</th>
                  </tr>

                  <tr
                    v-for="(item, index) in OnlineCourseOpenNum.onlineCourseOpenRank"
                    :key="index"
                    v-show="OnlineCourseOpenNum.onlineCourseOpenRank.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.teacher }}</td>
                    <td>{{ item.schoolname }}</td>
                    <td>{{ item.level }}</td>
                    <td>{{ item.num }}</td>
                  </tr>

                  <tr v-show="OnlineCourseOpenNum.onlineCourseOpenRank.length == 0" class="nothing">
                    <td colspan="7">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name" style="margin-top: 50px">表21 开课期数排名（前十五名）</div>

              <h5 style="margin-top: 50px">3.1.4 在线精品课程选课数据</h5>
              <div class="chart_box">
                <p>
                  截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计选课人数{{
                    getUtils_Fun(OnlineCourseSelectNum.onlineCourseTotalSelectNum)
                  }}人，选课人数最多的课程是{{
                    OnlineCourseSelectNum.onlineCourseSelectRank[0].schoolname
                  }}的《{{
                    OnlineCourseSelectNum.onlineCourseSelectRank[0].name
                  }}》，选课人数排名（前十五名）的课程信息如表22所示：
                </p>
                <div class="biaoge">
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    bordercolor="#fff"
                    class="course"
                  >
                    <tr>
                      <th>排名</th>
                      <th>课程</th>
                      <th>课程负责人</th>
                      <th>所属院校</th>
                      <th>级别</th>
                      <th>开课期数</th>
                    </tr>

                    <tr
                      v-for="(item, index) in OnlineCourseSelectNum.onlineCourseSelectRank"
                      :key="index"
                      v-show="OnlineCourseSelectNum.onlineCourseSelectRank.length > 0"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.teacher }}</td>
                      <td>{{ item.schoolname }}</td>
                      <td>{{ item.level }}</td>
                      <td>{{ item.num }}</td>
                    </tr>

                    <tr
                      v-show="OnlineCourseSelectNum.onlineCourseSelectRank.length == 0"
                      class="nothing"
                    >
                      <td colspan="7">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name" style="margin-top: 50px">表22 选课人数排名（前十五名）</div>
              </div>
            </div>
          </div>

          <div class="chart_box">
            <h3>4 视频公开课运行监测情况分析</h3>
            <p>
              依据监测平台统计，截止到{{ nowYear }}年{{ nowMonth }}月{{
                nowDay
              }}日，视频公开课共建{{
                VideoCourseRunAnalysis.videoCourseNunForType.value[4]
              }}门，其中， 国家规范教材有{{
                VideoCourseRunAnalysis.videoCourseNunForType.value[0]
              }}门、课程思政示范课有{{
                VideoCourseRunAnalysis.videoCourseNunForType.value[1]
              }}门、公共基础课有{{
                VideoCourseRunAnalysis.videoCourseNunForType.value[2]
              }}门、教学能力比赛比赛获奖作品有{{
                VideoCourseRunAnalysis.videoCourseNunForType.value[3]
              }}门。 目前，视频公开课已有{{
                VideoCourseRunAnalysis.videoCourseCoreIndicator["参建院校"]
              }}所院校和{{
                VideoCourseRunAnalysis.videoCourseCoreIndicator["教师参建人次"]
              }}名教师参与建设与应用；总访问量达{{
                getUtils_Fun(VideoCourseRunAnalysis.videoCourseCoreIndicator["总访问量"])
              }}次，总开课期数为{{
                VideoCourseRunAnalysis.videoCourseCoreIndicator["总开课期数"]
              }}期，总课时数为{{
                getUtils_Fun(VideoCourseRunAnalysis.videoCourseCoreIndicator["总课时数"])
              }}小时，总选课人数{{
                getUtils_Fun(VideoCourseRunAnalysis.videoCourseCoreIndicator["总选课人数"])
              }}人。
            </p>
            <p>具体建设与应用情况如下：</p>
            <h4>4.1 各省视频公开课建设情况</h4>
            <div class="chart_box">
              <p>
                截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课课程总计{{
                  ProvinceVideoCourseBuild.videoCourseNum
                }}门，其中，{{
                  ProvinceVideoCourseBuild.videoCourseProvinceRank[0].province
                }}省参与建设课程数量最多，共{{
                  ProvinceVideoCourseBuild.videoCourseProvinceRank[0].total
                }}门，具体各省参建课程数量排名（前十五名）如下表所示：
              </p>
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>参建课程数</th>
                    <th>选课人数</th>
                  </tr>

                  <tr
                    v-for="(item, index) in ProvinceVideoCourseBuild.videoCourseProvinceRank"
                    :key="index"
                    v-show="ProvinceVideoCourseBuild.videoCourseProvinceRank.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.province }}</td>
                    <td>{{ item.total }}</td>
                    <td>{{ item.studynum }}</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name" style="margin-top: 50px">
                表 33 各省参建视频公开课数量排名（前十五名）
              </div>

              <h4 style="margin-top: 50px">4.2 视频公开课访问情况</h4>
              <div class="chart_box">
                <p>
                  截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计访问量{{
                    getUtils_Fun(VideoCourseVisit.videoCourseTotalVisitNum)
                  }}，访问量最高的课程是{{
                    VideoCourseVisit.videoCourseVisitRank[0].schoolname
                  }}的《{{
                    VideoCourseVisit.videoCourseVisitRank[0].name
                  }}》，访问量排名前（十五名）的课程信息如下：
                </p>
                <div class="biaoge">
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    bordercolor="#fff"
                    class="course"
                  >
                    <tr>
                      <th>排名</th>
                      <th>课程</th>
                      <th>课程负责人</th>
                      <th>所属院校</th>
                      <th>课程类型</th>
                      <th>访问量</th>
                    </tr>

                    <tr
                      v-for="(item, index) in VideoCourseVisit.videoCourseVisitRank"
                      :key="index"
                      v-show="VideoCourseVisit.videoCourseVisitRank.length > 0"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.courseclass }}</td>
                      <td>{{ item.schoolname }}</td>
                      <td>{{ item.platform }}</td>
                      <td>{{ item.num }}</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name" style="margin-top: 30px">
                  表 34 视频公开课访问量排名（前十五名）
                </div>

                <h4 style="margin-top: 100px">4.3 视频公开课选课情况</h4>
                <div class="chart_box">
                  <p>
                    截止到{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计选课人数{{
                      getUtils_Fun(VideoCourseSelect.videoCourseTotalSelectNum)
                    }}人，选课人数最多的课程是{{
                      VideoCourseSelect.videoCourseSelectRank[0].schoolname
                    }}的《{{
                      VideoCourseSelect.videoCourseSelectRank[0].name
                    }}》，选课人数前（十五名）的课程信息如下：
                  </p>
                  <div class="biaoge">
                    <table
                      border="0"
                      cellpadding="0"
                      cellspacing="0"
                      width="100%"
                      bordercolor="#fff"
                      class="course"
                    >
                      <tr>
                        <th>排名</th>
                        <th>课程</th>
                        <th>课程负责人</th>
                        <th>所属院校</th>
                        <th>课程类型</th>
                        <th>选课人数</th>
                      </tr>

                      <tr
                        v-for="(item, index) in VideoCourseSelect.videoCourseSelectRank"
                        :key="index"
                        v-show="VideoCourseSelect.videoCourseSelectRank.length > 0"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.teacher }}</td>
                        <td>{{ item.schoolname }}</td>
                        <td>{{ item.platform }}</td>
                        <td>{{ item.num }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="chart_name" style="margin-top: 50px">
                    表 35 视频公开课选课人数排名（前十五名）
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-backtop></el-backtop>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import mapChart from "@/components/chart/mapChart.vue"; // 地图

import moment from "moment";

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    distributionChart,
    mapChart,
  },
  data() {
    return {
      completeMathodNum: 0,
      allLevelTotalLoginUser: 0,
      zykTotalVisit: 0,
      countryZykTotalVisit: 0,
      twoGetCountry: {},
      year: "",
      yearAndMonthly: "",
      yearMonthText: "",
      zykStatus: "已立项",
      dataAll: {
        dataList: [],
      },
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      color: [
        "#ffd9d9",
        "#ff0000",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ],
      header: {
        allHostUnit: "",
        coHostUnit: [],
        endTime: "",
        hostUnit: "",
        startTime: "",
        status: "",
        zykName: "",
        zykNum: "",
      },
      // 各校等级,覆盖专业
      LeaveUp: {
        dataList: [],
        Coveringspecialties: {},
        vocationalschool: {},
        Secondaryduty: {},
        Vocational: {},
      },
      // 图 1 用户分布
      userTypeHand: {
        dataList: [],
        total: null,
        studentNum: 0,
        teacherNum: 0,
        total: 0,
      },
      // 用户类型分布
      userTypeList: {
        dataList: [],
        legendList: [],
        studentNum: 0,
        teacherNum: 0,
        total: 0,
      },
      // 用户访问量
      userTalk: {
        dataList: [],
        legendList: ["教师", "学生"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        teacherTotal: null,
        studentTotal: null,
      },
      // 数据总览
      courseTypeNum: {
        dataList: [],
        joinSchool: {},
        joinComp: {},
        total: 0,
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        schoolNum: [],
        companyNum: [],
        maxArr: [],
      },

      // 课程被访问总量
      courseTalk: {
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        total: 0,
      },

      // 课程被访问量排名
      courseTalkTable: {
        dataList: [],
        MaxArr: [],
        total: null,
      },

      zykCourseRanks: {
        dataList: [],
        MaxArr: {},
      },

      // 资源访问情况
      resource: {
        dataList: [],
        transverse: [],
      },
      // 各类型资源数量
      typeResources: {
        dataList: [],
        legendList: [],
        sucai: {},
        rongliang: {},
      },

      // 各类资源占比
      educationLevel: {
        resourceCapacityNum: 0,
        dataList: [],
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        video: {},
        xuni: {},
        Max: {},
        total: null,
      },

      educationLevel1: {
        dataList: [],
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        video: {},
        xuni: {},
        Max: {},
        total: null,
      },
      educationLevel218: {
        dataList: [],
        num: 0,
        num2: 0,
        num3: "",
        num4: 0,
        num5: [],
        num6: [],
        num7: [],
        zykCount: 0,
      },

      // 获取资源访问量排名前15
      resourceTable: {
        dataList: [],
        MaxArr: [],
        Max: {},
        MaxZykname: {},
        resourceAvg: null,
        resourceTotal: null,
      },

      // 获取省份用户数排名 前（15名）
      getUser: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], // 柱状图，折线图颜色
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 各省在线学习人数排名（前十五）
      provinceStudy: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"], // 柱状图，折线图颜色
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 各省交流互动量排名（前十五名）
      provinceTalking: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        SecArr: [],
        total: null,
      },
      // 课程数量分布
      curriculum: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 获取省份教师数排名前15
      teacherProvince: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },

      // 素材资源量排名
      sourceMater: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      sourceMater2171: {
        dataList: [],
        legendList: [],
      },
      sourceMater2172: {
        dataList: [],
        legendList: [],
      },
      sourceMater2173: {
        dataList: [],
        legendList: [],
      },

      // 各省访问资源数排名
      visitProvince: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },
      // 获取区间内每月新增用户数
      userAdd: {
        dataList1: [],
        dataList2: [],

        sAtdatas: [],
        Stotal: null,
        Ttotal: null,
        sAtlegendList: ["学生", "教师"],
        legendList: ["学生", "教师", "社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 获取区间内每月新增用户数
      userTimeTalk: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 新增课程数
      courseNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 新增课程趋势
      courseTrend: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },

      // 新增资源数
      resourceNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },

      // 新增资源趋势
      resourceVisits: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      resourceLevel: {
        dataList: [],
        total: null,
        countryNum: {},
        provinceNum: {},
        schoolNum: {},
      },

      // 用户建设
      userConstruction: {
        dataList: [],
        userData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
        userTotal: null,
        tearchNum: {},
        studentNum: {},
        socialNum: {},
        EnterpriseNum: {},
        standardcourse: {},
      },
      // 访问总体
      talkAll: {
        resource: null,
        course: null,
        user: null,
      },
      // 学生类型整体情况(单位：人)
      studentConstruction: {
        dataList: [],
        total: 0,
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
      },

      // 近一年社会学习者和企业用户访问情况
      socialAndenterprise: {
        dataList: [],
        legendList: ["社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
      },

      // 获取课程建设
      getcourse: {
        dataList: [],
        individualization: {},
        Standardization: {},
        transverseData: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        total: null,
      },
      courseDataAll: {
        name: null,
        zykDiv: null,
        zykName: null,
      },
      // 获取专业大类
      getmajor: {
        dataList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        MaxArr: {},
        Second: {},
        total: null,
      },
      // 资源库访问情况排名（前十五名）
      getzykTable: {
        dataList: [],
        datas: [],
        transverseData: [],
        FristArr: [],
        SecArr: [],
        ThrArr: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
      },
      // 资源库用户活跃情况
      getzykACtive: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        Thrid: {},
      },
      // 2.2.1.各省用户建设及应用
      userProvince: {
        dataList: [],
        from: {},
        studentUser: {},
        mapdatas: [],
        mapcolorList: ["#ffd9d9"],
        MaxArr: [],
        onilneMax: {},
        total: null,
        talkTotal: null,
        studyTotal: null,
      },
      countryLevelUserProvince: {
        // 2.1.5.2.各省国家级资源库用户建设与应用情况
        dataList: [],
        userTotal: 0,
        maxUserProvinceInfo: { province: "", maxValue: 0 },
        formunInfo: { province: "", total: 0, maxValue: 0 },
        activeUserInfo: { province: "", total: 0, maxValue: 0 },
      },

      // 各省课程建设及应用
      curriculProvince: {
        dataList: [],
        MaxArr: [],
        SerArr: [],
        total: null,
        stotal: null, // 标准化课程总数
        ptotal: null, // 个性化课程总数
        standard: {},
        personality: {},
      },

      // 资源库省份资源建设情况
      disksNum: {
        total: null,
        totalLog: null,
        dataList: [],
        MaxArr: [],
        buildMaxArr: [],
        buildMax: {},
        maxProvince: {},
      },
      disksNum_top: [],
      disksNum_last: [],
      // 资源库用户运行情况
      zykuserYun: {
        // 资源库用户月活情况分析
        userActiveTotal: null,
        userActiveData: [],
        userActiveTranserve: [],
        userActiveTotals: null,

        userActivelogNum: null,
        userActiveRoleData: [],
        userActiveRoleTranserve: [],
        userActiveRolelegendList: [],

        roleStudent: {},
        roleTeacher: {},
        roleEnterprise: {},
        roleSocial: {},

        userActiveMonthTransverseData: [],
        userActiveMonthDataList: [],
      },

      // 访问情况排名(前十五、后十五)
      userTop: {
        fristTop15: [],
        fristMax: [],
        last15: [],
        lastMax: [],
      },
      zykAdd: {
        dataList: [],
      },
      //  资源库资源运行情况 （新增资源数） +（资源访问量）
      zyktalk: {
        total: null,
        totalLog: null,
        newRank: [],
        logRank: [],
        MaxArr: [],
        Top: {},
      },
      CountryUserAdd: {
        dataList: [],
        transverseData: [],
        legendList: ["教师", "学生"],
        Stotal: null,
        Ttotal: null,
      },
      CountryCurAdd: {
        // 月活
        userActiveMonthdataList: [],
        userActiveMonthTransverseData: [],
        userActiveTotal: null,
        // 用户月活 + 访问
        teacherActive: {},
        studentActive: {},
        societyActive: {},
        enterpriseActive: {},
        num: null,
        logNum: null,
        // 用户访问趋势图
        userVisitDataList: [],
        userVisitTransverseData: [],
        userVisitLegendList: [],
      },

      CountryVisit: {
        FristdataList: [],
        LastdataList: [],
        FristZykVisit: {},
      },

      CountryResourcesAdd: {
        total: null,
        logRank: null,
        newRank: [],
        logRank: [],
        visitRankTop1: {},
      },
      CountryCuourse: {
        courseTotal: null,
        dataList: [],
        transverseData: [],
      },
      CountryCourseVisit: {
        dataList: [],
        Max: {},
      },
      // 在线精品课
      ByLevel: {
        dataList: [],
        total: null,
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {},
      },
      Platform: {
        dataList: [],
        Plat: {},
        total: null,
      },
      catorStat: {
        dataList: [],
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
        datas7: {},
      },
      couseRank: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程总访问量排名
      couseAll: {
        dataList: [],
        MaxArr: [],
        total: null,
      },

      // 课程开课期数
      couseOpen: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程选课人次排名
      courseSelect: {
        dataList: [],
        MaxArr: {},
        total: null,
      },

      courseVideo: {
        dataList: [],
        datas1: [],
        datas2: [],
        datas3: [],
        datas4: [],
        datas5: [],
      },
      courseVideo2: {
        dataList: [],
        ploaNum: {},
      },
      courseVideo3: {
        dataList: [],
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
        datas7: {},
        datas8: {},
      },
      courseTop: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 视频公开课访问情况
      courseVideoPen: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 视频选课
      courseVideoSel: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      projectTop: {
        // 图三 参加单位注册用户数排名
        dataList: [],
        colorList: [],
        transverseData: [],
      },

      resourcesMonth: {
        // 图4 资源库各类型素材资源新增情况
        dataList: [],
        transverseData: [],
        legendList: [],
        colorList: [],
        total: 0,
      },

      visitsMonth: {
        // 图7 课程访问情况
        dataList: [],
        transverseData: [],
        colorList: [],
        legendList: [],
        total: 0,
      },

      totalNum: 0,
      loading: "", // 是否导出加载中
      startDay: "",
      endDay: "",

      // 现在的时间
      nowMonth: "",
      nowDay: "",
      type: "",
      nowYear: "",
      Quarter: "",

      countryCourseCountProvinceRank_obj: {},
      getCountryProvinceZykBuild: {},
      runCase: {},
      analysis: {},
      courseBuild: {},
      getResource: {},
      getProvince: {},
      getProvinceUser: {},
      CourseBuildAndAnalysis: {},
      countryZyk: {},
      ZykStudentUser: {},
      ZykTeacherUser: {},
      ZykResourceNewAddCase: {},
      ZykStudentUserVisitCase: {},
      ZykCourseNewAddCase: {},
      ZykTeacherUserVisitCase: {},
      ZykEnterpriseUserVisitCase: {},
      ZykSocietyUserVisitCase: {},
      ZykCourseVisitCase: {},
      ZykResourceVisitCase: {},
      ProfessionAnalysis: {},
      ZyBuildAndAnalysis: {},
      ZykStudentUserNewAddCase: {},
      ZykTeacherUserNewAddCase: {},
      ZykEnterpriseUserNewAddCase: {},
      ZykSocietyUserNewAddCase: {},
      getZykResourceNewAddCase: {},
      getZykCourseNewAddCase: {},
      getZykStudentUserVisitCase: {},
      getZykTeacherUserVisitCase: {},
      getZykEnterpriseUserVisitCase: {},
      getZykSocietyUserVisitCase: {},
      getZykCourseVisitCase: {},
      getZykResourceVisitCase: {},
      ZykActiveResourceRank: {},
      ZykBuildAnalysisLogRank: {},
      ZykActiveUserRank: {},
      CourseYearRunAnalysis: {},
      ProvinceBuildCourseNum: [],
      BigClassCourseNum: {},
      OnlineCourseVisitNum: {},
      OnlineCourseOpenNum: {},
      OnlineCourseSelectNum: {},
      VideoCourseRunAnalysis: {},
      ProvinceVideoCourseBuild: {},
      VideoCourseVisit: {},
      VideoCourseSelect: {},
      ProfessionVisitBar: {
        dataList1: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList2: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList3: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
        dataList4: {
          dataList1: {},
          dataList2: {},
          dataList3: {},
          dataList4: {},
        },
      },
    };
  },
  created() {
    if (this.$route.query) {
      const { token } = this.$route.query;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.$route.query.endDay.slice(0, 4);
      if (
        this.$route.query.startDay.indexOf("01-01") !== -1 &&
        this.$route.query.endDay.indexOf("03-31") !== -1 &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第1季度";
      } else if (
        this.$route.query.startDay.indexOf("04-01") !== -1 &&
        this.$route.query.endDay.indexOf("06-30") !== -1 &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第2季度";
      } else if (
        this.$route.query.startDay.indexOf("07-01") !== -1 &&
        this.$route.query.endDay.indexOf("09-30") !== -1 &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第3季度";
      } else if (
        this.$route.query.startDay.indexOf("10-01") !== -1 &&
        this.$route.query.endDay.indexOf("12-31") !== -1 &&
        this.$route.query.type == 2
      ) {
        this.Quarter = "第4季度";
      }

      sessionStorage.setItem("lrmv2token", token);
      const { zykid } = this.$route.query;
      sessionStorage.setItem("zykId", zykid);
    }
    this.nowDate(); //   获取当前时间日期
    this.dataAllHandler(); //  数据总览
    this.leaveHanderl(); //  各校等级,覆盖专业
    this.userTypeHandler(); //  图 1 用户分布
    // this.userType(); //  用户类型分布
    this.courseNum(); //  課程數量
    this.zykCourseRankHandler(); //  区间内资源库课程访问量排名
    // 1.1.3  资源存储量 + 资源类型
    this.resourcesNumber(); //  资源存储量
    this.resourcesProportion(); //  各类型资源占比
    // 1.2 各省市建设及应用情况分析
    // this.getuser(); //  获取省份用户数排名前15
    // this.provinceStudyNum(); //  各省在线学习人数排名（前十五）
    // this.provinceTalk(); //  各省交流互动量排名（前十五名）

    // 1.3.1    用户运行情况
    // this.curriculumNum(); //  课程数量分布
    // this.teacherNumType(); //  获取省份教师数（前十五名）
    // this.sourceMaterial(); //  素材资源量排名
    // this.visitProvinceHandler(); //  各省建设资源数排名

    // 1.3.2    课程运行情况
    // this.userAddHanderl(); //  获取区间内每月新增用户数
    // this.userTimeTalkHanderl(); //  用户访问量趋势
    // this.courseNewHandler(); //  区间课程新增

    // this.courseTrendHandler()           //  区间课程新增趋势

    // 1.3.3       资源运行情况
    // this.resourceNewHandler()           //  区间新增课程数
    // this.resourceVisitsHandler()        //  区间新增课程趋势

    // 2.1
    this.resourceLevelHandler(); //  专业教学资源库应用分析
    this.userConstructionHandler(); //  用户建设

    // 2.2.1  用户建设及应用情况
    // this.talkAllHandler(); //   获取访问总体情况
    // this.studentConstructionHandler(); //   学生类型整体情况
    this.socialAenterpriseHandler(); //   近一年社会学习者和企业用户访问情况
    // this.getcourseHandler(); //   获取国家端-课程画像-课程数量图
    this.courseAllHandler(); //   课程整体情况

    // 2.1.4  国家级资源库应用情况分析
    // this.getmajorHandler(); //   覆盖专业大类分析
    // this.getzykHandler(); //   资源库访问情况排名（前十五名）
    this.getzykACtiveHandler(); //   资源库活跃情况

    // 2.2.1  各省用户建设及应用
    // this.getuserProHandeler(); //   各省用户建设及应用
    this.curriculProvinceHandler(); //   资源库课程介绍
    this.disksNumHandler(); //   资源库省份资源建设情况
    this.zykuserYunHandler(); //   资源库用户运行情况

    this.fristAlast(); //   访问情况排名(前十五、后十五)
    this.zyktalkHandler(); //   资源库资源运行情况

    this.CountryUserAddHandler();
    this.CountryCurAddHandler();
    this.CountryVisitsRank();
    this.CountryCuourseAddHandler();
    this.CountryCurVisitHandler();
    this.CountryResourcesAddHandler();

    // // 第三部分
    // // 3.1 标题部分
    // this.ByLevelHandler()               //    在线精品课
    // this.PlatformHandler()              //    平台数量和平台课程数（前三）
    // this.catorStatHandler()

    // // 3.1.1  3.1.2  3.1.3  3.1.4
    // this.courseProvinceRank()           //    在线精品课_参加课程数量各省排名
    // this.courseAlltalk()                //    在线精品课访问情况
    // this.couseOpenHandler()             //    在线精品课开课期数
    // this.courseSelection()              //    课程选课人次排名

    // // 第四部分
    // // 4.1 标题部分
    // this.ByLevelcourseVideo()           //    视频公开课建设及应用情况
    // this.PlatformVideoHandler()
    // this.catorStatVideoHandler()

    // // 4.1.1   4.1.2   4.1.3
    // this.courseTopHandler()
    // this.courseVideoPenHandler()
    // this.courseVideoSelHandler()

    // 各省用户建设及应用
    this.getProvinceUserBuildApply_Fun();

    // 各省课程建设及应用情况
    this.getProvinceCourseBuildApply_Fun();
    // 1.2.3 各省资源建设及应用
    this.getProvinceResourceBuildApply_Fun();

    // 1.3.1 用户运行分析
    this.getUserRunAnalysis_Fun();
    // 1.3.2 课程运行分析
    this.getCourseRunAnalysis_Fun();
    // 1.3.3 资源运行分析
    this.getResourceRunAnalysis_Fun();

    // 1.2 203个国家级资源库建设与应用分析
    this.getCountryAllZykBuildAndAppAnalysis_Fun();
    // 1.2.1 用户建设及应用分析
    this.getCountryUserBuildAndAppAnalysis_Fun();
    // 1.2.2 课程建设及应用分析
    this.getCourseBuildAndAppAnalysis_Fun();
    // 2.1.3 资源建设及应用分析
    this.getResourceBuildAndAppAnalysis_Fun();
    // 2.1.4 按专业大类汇总统计维度分析
    this.getMajorCountAnalysis_Fun();
    // 2.1.4.1~2.1.4.4 资源库专业大类排名前四运行分析报告
    this.getTopFourProfessionAnalysis_Fun();

    // 2.1.5.1 各省国家级资源库建设与应用情况概览
    this.getCountryZykProvinceBuildAndAnalysisOutline_Fun();
    // 2.1.5.2 各省国家级资源库用户建设与应用情况
    this.getCountryZykProvinceUserBuildAndAnalysis_Fun();
    // 2.1.5.3 各省国家级资源库课程建设及应用情况
    this.getCountryZykProvinceCourseBuildAndAnalysisCase_Fun();
    // 2.1.5.4 各省国家级资源库资源建设及应用情况
    this.getCountryProvinceZykBuildAndAnalysisCase_Fun();

    // 2.1.6.1 国家级资源库社会学习者新增情况
    this.countryZykSocietyUserNewAddCase_Fun();
    this.getCountryZykStudentUserNewAddCase_Fun();
    this.getCountryZykTeacherUserNewAddCase_Fun();
    this.getCountryZykEnterpriseUserNewAddCase_Fun();
    // 2.1.6.2 国家级资源库资源新增情况
    this.getCountryZykResourceNewAddCase_Fun();
    // 2.1.6.3 国家级资源库课程新增情况
    this.getCountryZykCourseNewAddCase_Fun();
    // 2.1.6.4 国家级资源库学生访问情况
    this.getCountryZykStudentUserVisitCase_Fun();
    // 2.1.6.4 国家级资源库教师访问情况
    this.getCountryZykTeacherUserVisitCase_Fun();
    this.getCountryZykEnterpriseUserVisitCase_Fun();
    this.getCountryZykSocietyUserVisitCase_Fun();
    this.getCountryZykCourseVisitCase_Fun();
    this.getCountryZykResourceVisitCase_Fun();
    this.getCountryZykVisitCaseTotalByType();
    // 2.1.7.1 按资源量维度排名
    this.getYearReportCountryZykActiveResourceRank_Fun();

    // 2.1.7.2 按访问量维度排名
    this.getCountryZykBuildAnalysisLogRank_Fun();
    // 2.1.7.3 按库内活跃用户数维度排名
    this.getYearReportCountryZykActiveUserRank_Fun();
    // 2.1.7.4 2022年综合应用排行排名
    this.getCompositeRank_Fun();

    // 2.1.8 203个国家级资源库覆盖2021版专业目录情况分析
    this.getCountryZykCoverProfessionAnalysis_Fun();

    // 2.2 国家及省市校级专业教学资源库运行监测情况分析
    this.getCountryProvinceCitySchoolLevelProfessionZykRunCase_Fun();
    // 2.2.1 用户建设及应用
    this.getUserBuildAndAnalysis_Fun();

    // 2.2.2 课程建设及应用
    this.getCourseBuildAndAnalysis_Fun();
    // 2.2.3 资源建设及应用
    this.getResourceBuildAndAnalysis_Fun();
    // 2.2.4.1 各省资源库建设与应用情况概览
    this.getProvinceZykBuildAndAnalysis_Fun();
    // 2.2.4.2 各省用户建设与应用情况
    this.getProvinceUserBuildAndAnalysis_Fun();
    // 2.2.4.3 各省课程建设及应用情况
    this.getProvinceCourseBuildAndAnalysis_Fun();
    // 2.2.4.4 各省资源建设及应用情况
    this.getProvinceZyBuildAndAnalysis_Fun();
    // 2.2.5.1 资源库学生用户新增情况
    this.getZykStudentUserNewAddCase_Fun();
    // 2.2.5.1 资源库教师用户新增情况
    this.getZykTeacherUserNewAddCase_Fun();
    // /资源库企业用户新增情况
    this.getZykEnterpriseUserNewAddCase_Fun();
    //  2.2.5.1 资源库社会学习者用户新增情况
    this.getZykSocietyUserNewAddCase_Fun();
    this.getZykResourceNewAddCase_Fun();
    this.getZykCourseNewAddCase_Fun();
    this.getZykStudentUserVisitCase_Fun();
    this.getZykTeacherUserVisitCase_Fun();
    this.getZykEnterpriseUserVisitCase_Fun();
    this.getZykSocietyUserVisitCase_Fun();
    this.getZykCourseVisitCase_Fun();
    this.getZykResourceVisitCase_Fun();
    this.getYearReportZykActiveResourceRank_Fun();
    this.getZykBuildAnalysisLogRank_Fun();
    this.getYearReportZykActiveUserRank_Fun();
    this.getOnlineCourseYearRunAnalysis_Fun();
    this.getProvinceBuildCourseNum_Fun();
    this.getProfessionBigClassCourseNum_Fun();
    this.getOnlineCourseVisitNum_Fun();
    this.getOnlineCourseOpenNum_Fun();
    this.getOnlineCourseSelectNum_Fun();
    this.getVideoCourseRunAnalysis_Fun();
    this.getProvinceVideoCourseBuild_Fun();
    this.getVideoCourseVisit_Fun();
    this.getVideoCourseSelect_Fun();
    //2.2.5.4
    this.getZykVisitCaseTotalByType();
  },

  methods: {
    getReduceOrAdd(num) {
      const data =
        num > 0 ? "增加" + this.getUtils_Fun(num) : "减少" + this.getUtils_Fun(Math.abs(num));
      return data;
    },
    getUtils_Fun(num) {
      const data =
        num > 100000000 ? `${(num / 100000000).toFixed(2)}亿` : `${(num / 10000).toFixed(2)}万`;
      return data;
    },
    formatPersonNum(num) {
      const data =
        num > 100000000 ? `${(num / 100000000).toFixed(0)}亿` : `${(num / 10000).toFixed(0)}万`;
      return data;
    },
    formatValue(num) {
      return Math.floor(num);
    },
    getDailyVist(num) {
      const day_num = this.getDifferTime(this.startDay, this.endDay);
      let daily_num = num / day_num;
      return this.getUtils_Fun(daily_num);
    },
    getDifferTime(startDate, endDate) {
      const startTime = new Date(Date.parse(startDate.replace(/-/g, "/"))).getTime();
      const endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
      let dates = Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24);
      return dates;
    },
    // 各省用户建设及应用
    getProvinceUserBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildApply, {
          loading: false,
        })
        .then((res) => {
          this.getUser.userTotal = res.data.userTotal; // 注册用户总计
          this.getUser.dataList = res.data.studyUserNumRank.value;
          this.getUser.legendList = res.data.studyUserNumRank.name;
          const datas = [];
          for (let i = 0; i < this.getUser.dataList.length; i++) {
            this.getUser.total += this.getUser.dataList[i];
            datas.push({
              name: this.getUser.legendList[i],
              value: this.getUser.dataList[i],
            });
          }
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          datas.sort(Sort);
          this.getUser.sortMax = datas;
          this.getUser.MaxArr = this.getUser.sortMax[0];

          this.provinceStudy.dataList = res.data.userRankInfo.value;
          this.provinceStudy.legendList = res.data.userRankInfo.name;
          const datas1 = [];
          for (let i = 0; i < this.provinceStudy.dataList.length; i++) {
            this.provinceStudy.total += this.provinceStudy.dataList[i];
            datas1.push({
              name: this.provinceStudy.legendList[i],
              value: this.provinceStudy.dataList[i],
            });
          }
          // 数组排序
          function Sort1(a, b) {
            return b.value - a.value;
          }
          datas1.sort(Sort1);
          this.provinceStudy.sortMax = datas1;
          this.provinceStudy.MaxArr = this.provinceStudy.sortMax[0];

          this.provinceTalking.dataList = res.data.InteractionRankInfo.value;
          this.provinceTalking.legendList = res.data.InteractionRankInfo.name;
          const datas2 = [];
          for (let i = 0; i < this.provinceTalking.dataList.length; i++) {
            this.provinceTalking.total += this.provinceTalking.dataList[i];
            datas2.push({
              name: this.provinceTalking.legendList[i],
              value: this.provinceTalking.dataList[i],
            });
          }
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          datas2.sort(Sort);
          this.provinceTalking.sortMax = datas2;
          this.provinceTalking.MaxArr = this.provinceTalking.sortMax[0];
          this.provinceTalking.SecArr = this.provinceTalking.sortMax[1];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.2.2 各省课程建设及应用情况
    getProvinceCourseBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.curriculum.totalCourse = res.data.totalCourse;
            this.curriculum.dataList = res.data.courseProvinceRanking.dataList;
            this.curriculum.legendList = res.data.courseProvinceRanking.transverseData;
            const datas = [];
            for (let i = 0; i < this.curriculum.dataList.length; i++) {
              this.curriculum.total += this.curriculum.dataList[i];
              datas.push({
                name: this.curriculum.legendList[i],
                value: this.curriculum.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.curriculum.sortMax = datas;
            this.curriculum.MaxArr = this.curriculum.sortMax[0];

            this.teacherProvince.dataList = res.data.provinceTeacherBuildRanking.value;
            this.teacherProvince.legendList = res.data.provinceTeacherBuildRanking.name;
            const datas1 = [];
            for (let i = 0; i < this.teacherProvince.dataList.length; i++) {
              this.teacherProvince.total += this.teacherProvince.dataList[i];
              datas1.push({
                name: this.teacherProvince.legendList[i],
                value: this.teacherProvince.dataList[i],
              });
            }
            // 数组排序
            function Sort1(a, b) {
              return b.value - a.value;
            }
            datas1.sort(Sort1);
            this.teacherProvince.sortMax = datas1;
            this.teacherProvince.MaxArr = this.teacherProvince.sortMax[0];
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.2.3 各省资源建设及应用
    getProvinceResourceBuildApply_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceResourceBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.sourceMater.resourceTotalCount = res.data.resourceTotalCount;
            for (let i = 0; i < res.data.resourceRanking.length; i++) {
              this.sourceMater.legendList.push(res.data.resourceRanking[i].province);
              this.sourceMater.dataList.push(res.data.resourceRanking[i].num);
              this.sourceMater.total += this.sourceMater.dataList[i];
            }

            // 数组排序
            function Sort1(a, b) {
              return b.num - a.num;
            }
            res.data.resourceRanking.sort(Sort1);
            this.sourceMater.sortMax = res.data.resourceRanking;
            this.sourceMater.MaxArr = this.sourceMater.sortMax[0];

            this.visitProvince.dataList = res.data.provinceVisitResourceRank.value;
            this.visitProvince.legendList = res.data.provinceVisitResourceRank.name;

            const datas1 = [];
            for (let i = 0; i < this.visitProvince.dataList.length; i++) {
              this.visitProvince.total += this.visitProvince.dataList[i];
              datas1.push({
                name: this.visitProvince.legendList[i],
                value: this.visitProvince.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas1.sort(Sort);
            this.visitProvince.sortMax = datas1;
            this.visitProvince.MaxArr = this.visitProvince.sortMax[0];
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.3.1 用户运行分析
    getUserRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getUserRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          //  图13
          this.userAdd.transverse = res.data.countryReportUserMonthNew.enterprise.name;
          this.userAdd.dataList1.push(
            res.data.countryReportUserMonthNew.student.value,
            res.data.countryReportUserMonthNew.teacher.value
          );
          this.userAdd.dataList2.push(
            res.data.countryReportUserMonthNew.enterprise.value,
            res.data.countryReportUserMonthNew.social.value
          );
          this.userAdd.tran = [];
          this.userAdd.tran.push("社会学习者", "企业用户");
          this.userAdd.colorList = this.colorList;
          console.log(this.userAdd.dataList1, 520);
          const studentV = this.userAdd.dataList1[0];
          const teacherV = this.userAdd.dataList1[1];
          // 图 31
          this.userAdd.sAtdatas.push(studentV, teacherV);
          const enterpriseV = this.userAdd.dataList2[0];
          const socialV = this.userAdd.dataList2[1];

          const totalS = 0;
          const totalT = 0;
          let totalE = 0;
          let totalV = 0;

          studentV.forEach((item) => {
            this.userAdd.Stotal += item;
          });
          teacherV.forEach((item) => {
            this.userAdd.Ttotal += item;
          });

          enterpriseV.forEach((item) => {
            totalE += item;
          });

          socialV.forEach((item) => {
            totalV += item;
          });
          this.userAdd.total = this.userAdd.Stotal + this.userAdd.Ttotal + totalE + totalV;

          this.userTimeTalk.dataList = res.data.countryReportUserMonthVisits.value;
          let total = 0;
          res.data.countryReportUserMonthVisits.value.forEach((item) => {
            total += item;
          });
          this.userTimeTalk.dataList.forEach((item) => {
            this.userTimeTalk.total += item;
          });
          this.userTimeTalk.transverse = res.data.countryReportUserMonthVisits.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 1.3.2 课程运行分析
    getCourseRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getCourseRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            // 新增课程数
            this.courseNew.dataList = res.data.courseNew.value;
            this.courseNew.transverse = res.data.courseNew.name;
            this.courseNew.dataList.forEach((item) => {
              this.courseNew.total += item;
            });

            // 新增课程趋势
            this.courseTrend.dataList = res.data.courseVisits.value;
            this.courseTrend.transverse = res.data.courseVisits.name;
            this.courseTrend.dataList.forEach((item) => {
              this.courseTrend.total += item;
            });
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 1.3.3 资源运行分析
    getResourceRunAnalysis_Fun() {
      this.$axios
        .post(
          this.$apiurls.getResourceRunAnalysis,
          { endDay: this.endDay, startDay: this.startDay },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            // 新增资源数
            this.resourceNew.dataList = res.data.resourceNew.value;
            this.resourceNew.transverse = res.data.resourceNew.name;
            this.resourceNew.dataList.forEach((item) => {
              this.resourceNew.total += item;
            });

            // 性能增资源趋势
            this.resourceVisits.dataList = res.data.resourceVisits.value;
            this.resourceVisits.transverse = res.data.resourceVisits.name;
            this.resourceVisits.dataList.forEach((item) => {
              this.resourceVisits.total += item;
            });
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1 203个国家级资源库建设与应用分析
    getCountryAllZykBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryAllZykBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          const {
            companyBuild,
            resourceNum,
            schoolBuild,
            standardNum,
            totalZykVisitNum,
            zykCountryNum,
            zykUserNum,
          } = res.data;
          this.twoGetCountry = {
            companyBuild,
            resourceNum,
            schoolBuild,
            standardNum,
            totalZykVisitNum,
            zykCountryNum,
            zykUserNum,
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.1 用户建设及应用分析
    getCountryUserBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryUserBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.talkAll.resource = res.data.resourceCountVisitNum;
          this.talkAll.course = res.data.courseCountVisitNum;
          this.talkAll.user = res.data.userNum;
          const datas = [];
          for (let i = 0; i < res.data.userProfileMap.userProfileName.length; i++) {
            this.userTypeList.total += res.data.userProfileMap.userProfileNum[i];
            datas.push({
              name: res.data.userProfileMap.userProfileName[i],
              value: res.data.userProfileMap.userProfileNum[i],
            });
          }

          // 教师数量
          const tearch = datas.find((item) => item.name == "教师");
          this.userTypeList.tearchNum = tearch.value;
          // 学生数
          const student = datas.find((item) => item.name == "学生");
          this.userTypeList.studentNum = student.value;
          this.userTypeList.legendList = res.data.userProfileMap.userProfileName;
          this.userTypeList.dataList = datas;

          this.studentConstruction.dataList = res.data.studentType.map((item) => {
            const { name } = item;
            const { value } = item;
            return {
              name,
              value,
            };
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.2 课程建设及应用分析
    getCourseBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCourseBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.getcourse.courseNum = res.data.courseCountNum;
          this.getcourse.CourseDayVisitNum = res.data.CourseDayVisitNum;
          this.getcourse.courseMaxCount = res.data.courseMaxCount;
          this.getcourse.dataList = res.data.courseType.value;
          this.getcourse.total = this.getcourse.dataList[0] + this.getcourse.dataList[1];
          // this.getcourse.dataList.forEach((item) => {
          this.getcourse.transverseData = res.data.courseType.name;
          // });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 2.1.3 资源建设及应用分析
    getResourceBuildAndAppAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAppAnalysis, {
          loading: false,
        })
        .then((res) => {
          const { resourceAvg, resourceCapacityNum, resourceNum, resourceTotal, visitMaxResource } =
            res.data;
          this.educationLevel.resourceAvg = resourceAvg;
          this.educationLevel.resourceCapacityNum = resourceCapacityNum;
          this.educationLevel.resourceNum = resourceNum;
          this.educationLevel.resourceTotal = resourceTotal;
          if (visitMaxResource.zykName.indexOf("资源库") == -1) {
            visitMaxResource.zykName += "资源库";
          }
          this.educationLevel.visitMaxResource = visitMaxResource;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.4 按专业大类汇总统计维度分析
    getMajorCountAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getMajorCountAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 500);
          const { professionData } = res.data;
          this.getmajor.professionData = professionData;
          function Sort(a, b) {
            return b.value - a.value;
          }
          const data = res.data.professionDataList.sort(Sort);
          this.getmajor.dataList = data;

          this.getmajor.MaxArr = data[0];
          this.getmajor.Second = data[1];

          data.forEach((item) => {
            this.getmajor.total += item.value;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.4.1~2.1.4.4 资源库专业大类排名前四运行分析报告
    getTopFourProfessionAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getTopFourProfessionAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 333333);
          this.ProfessionAnalysis = res.data;
          this.bigClass1 = res.data.top1Data.bigClass;
          this.bigClass2 = res.data.top2Data.bigClass;
          this.bigClass3 = res.data.top3Data.bigClass;
          this.bigClass4 = res.data.top4Data.bigClass;
          this.getTopFourProfessionVisitBar_Fun(2, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top1Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top1Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top2Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top2Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top3Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top3Data.bigClass);

          this.getTopFourProfessionVisitBar_Fun(2, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(1, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(4, res.data.top4Data.bigClass);
          this.getTopFourProfessionVisitBar_Fun(3, res.data.top4Data.bigClass);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getTopFourProfessionVisitBar_Fun(type, professionBigClass) {
      this.$axios
        .post(
          this.$apiurls.getTopFourProfessionVisitBar,
          { type, professionBigClass },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 3333334);
          switch (professionBigClass) {
            case this.bigClass1:
              if (type == 2) {
                this.ProfessionVisitBar.dataList1.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList1.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList1.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList1.dataList4 = res.data;
              }

              break;
            case this.bigClass2:
              if (type == 2) {
                this.ProfessionVisitBar.dataList2.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList2.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList2.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList2.dataList4 = res.data;
              }
              break;
            case this.bigClass3:
              if (type == 2) {
                this.ProfessionVisitBar.dataList3.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList3.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList3.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList3.dataList4 = res.data;
              }
              break;
            case this.bigClass4:
              if (type == 2) {
                this.ProfessionVisitBar.dataList4.dataList1 = res.data;
              } else if (type == 1) {
                this.ProfessionVisitBar.dataList4.dataList2 = res.data;
              } else if (type == 4) {
                this.ProfessionVisitBar.dataList4.dataList3 = res.data;
              } else {
                this.ProfessionVisitBar.dataList4.dataList4 = res.data;
              }
              break;
            default:
              break;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.5.1 各省国家级资源库建设与应用情况概览
    getCountryZykProvinceBuildAndAnalysisOutline_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceBuildAndAnalysisOutline, {
          loading: false,
        })
        .then((res) => {
          this.getzykTable.dataList = res.data.CountryZykProvinceBuildAndAnalysis;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.5.2 各省国家级资源库用户建设与应用情况
    getCountryZykProvinceUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          this.userProvince.mapdatas = res.data.countryProvinceLogTotal;
          this.countryLevelUserProvince.userTotal = res.data.zykUserNum;
          this.countryLevelUserProvince.dataList = res.data.countryProvinceStatusActiveUserRank;
          this.countryLevelUserProvince.maxUserProvinceInfo.province =
            res.data.maxRegisteredCountryUsersProvince.province;
          this.countryLevelUserProvince.maxUserProvinceInfo.maxValue =
            res.data.maxRegisteredCountryUsersProvince.num;
          this.countryLevelUserProvince.formunInfo.total = res.data.countryForumLogProvinceNumTotal;
          this.countryLevelUserProvince.formunInfo.maxValue =
            res.data.maxInteractiveUsersProvince.num;
          this.countryLevelUserProvince.formunInfo.province =
            res.data.maxInteractiveUsersProvince.province;
          this.countryLevelUserProvince.activeUserInfo.total =
            res.data.countryProvinceStatusActiveUserTotal;
          this.countryLevelUserProvince.activeUserInfo.maxValue =
            res.data.countryProvinceStatusActiveUserRank[0].activeNum;
          this.countryLevelUserProvince.activeUserInfo.province =
            res.data.countryProvinceStatusActiveUserRank[0].province;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.5.3 各省国家级资源库课程建设及应用情况
    getCountryZykProvinceCourseBuildAndAnalysisCase_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykProvinceCourseBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          const {
            countryCourseCountProvinceRank,
            countryCoursePersonalityCountMax,
            countryCourseStandardCountMax,
            zykCourseBuildCountNum,
            zykCourseMaxProvince,
          } = res.data;
          let snum = 0;
          let pnum = 0;
          countryCourseCountProvinceRank.forEach((item) => {
            snum += item.snum;
            pnum += item.pnum;
          });
          this.countryCourseCountProvinceRank_obj = {
            countryCourseCountProvinceRank,
            countryCoursePersonalityCountMax,
            countryCourseStandardCountMax,
            zykCourseBuildCountNum,
            zykCourseMaxProvince,
            snum,
            pnum,
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.5.4 各省国家级资源库资源建设及应用情况
    getCountryProvinceZykBuildAndAnalysisCase_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryProvinceZykBuildAndAnalysisCase, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 222);
          const {
            countryResourceProvinceStateRank,
            countryResourceTotalLog,
            resourceVisitMaxProvince,
            zykBuildResourceCount,
            zykNumMaxProvince,
          } = res.data;
          this.getCountryProvinceZykBuild = {
            countryResourceProvinceStateRank,
            countryResourceTotalLog,
            resourceVisitMaxProvince,
            zykBuildResourceCount,
            zykNumMaxProvince,
          };
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getYearRange(year) {
      // 创建传入年份的开始时间
      const yearStart = new Date(year, 0, 1, 0, 0, 0, 0);

      // 创建传入年份的结束时间
      const yearEnd = new Date(year, 11, 31, 23, 59, 59, 999);

      // 格式化开始时间
      const startFormatted = this.formatDate(yearStart);

      // 格式化结束时间
      const endFormatted = this.formatDate(yearEnd);

      return {
        start: startFormatted,
        end: endFormatted,
      };
    },

    formatDate(date) {
      const year = date.getFullYear();
      const month = this.padZero(date.getMonth() + 1);
      const day = this.padZero(date.getDate());

      return `${year}-${month}-${day}`;
    },

    padZero(number) {
      return number < 10 ? `0${number}` : number;
    },
    // 2.1.6.1 国家级资源库社会学习者新增情况
    countryZykSocietyUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.countryZykSocietyUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 444);
          this.countryZyk = res.data;
          this.countryZyk.firstTotal = res.data.firstTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.countryZyk.secondTotal = res.data.secondTimeSocietyNum.reduce((a, b) => a + b, 0);
          this.countryZyk.dataList = [res.data.secondTimeSocietyNum, res.data.firstTimeSocietyNum];
          console.log(this.countryZyk, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.6.1 国家级资源库学生新增情况
    getCountryZykStudentUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykStudentUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 444);
          this.ZykStudentUser = res.data;
          this.ZykStudentUser.firstTotal = res.data.studentFirstTimeNum.reduce((a, b) => a + b, 0);
          this.ZykStudentUser.secondTotal = res.data.studentSecondTimeNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUser.dataList = [
            res.data.studentSecondTimeNum,
            res.data.studentFirstTimeNum,
          ];
          console.log(this.ZykStudentUser, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykTeacherUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykTeacherUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 444);
          this.ZykTeacherUser = res.data;
          this.ZykTeacherUser.firstTotal = res.data.firstTimeTeacherNum.reduce((a, b) => a + b, 0);
          this.ZykTeacherUser.secondTotal = res.data.secondTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUser.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          console.log(this.ZykTeacherUser, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykEnterpriseUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykEnterpriseUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 444);
          this.ZykEnterpriseUser = res.data;
          this.ZykEnterpriseUser.firstTotal = res.data.firstTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUser.secondTotal = res.data.secondTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUser.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          console.log(this.ZykEnterpriseUser, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykResourceNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykResourceNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, 333);
          this.ZykResourceNewAddCase = res.data;
          this.ZykResourceNewAddCase.firstTotal = res.data.firstTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykResourceNewAddCase.secondTotal = res.data.secondTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykResourceNewAddCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          console.log(this.ZykResourceNewAddCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.6.3
    getCountryZykCourseNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykCourseNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库课程新增情况");
          this.ZykCourseNewAddCase = res.data;
          this.ZykCourseNewAddCase.firstTotal = res.data.firstTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykCourseNewAddCase.secondTotal = res.data.secondTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykCourseNewAddCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          console.log(this.ZykCourseNewAddCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.6.4 国家级资源库学生访问情况
    getCountryZykStudentUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykStudentUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库课程新增情况111");
          this.ZykStudentUserVisitCase = res.data;
          this.ZykStudentUserVisitCase.firstTotal = res.data.firstTimeStudentNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUserVisitCase.secondTotal = res.data.secondTimeStudentNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUserVisitCase.dataList = [
            res.data.secondTimeStudentNum,
            res.data.firstTimeStudentNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykTeacherUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykTeacherUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库教师访问情况");
          this.ZykTeacherUserVisitCase = res.data;
          this.ZykTeacherUserVisitCase.firstTotal = res.data.firstTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUserVisitCase.secondTotal = res.data.secondTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUserVisitCase.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykEnterpriseUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykEnterpriseUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库企业访问情况");
          this.ZykEnterpriseUserVisitCase = res.data;
          this.ZykEnterpriseUserVisitCase.firstTotal = res.data.firstTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUserVisitCase.secondTotal = res.data.secondTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUserVisitCase.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykSocietyUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykSocietyUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库企业访问情况");
          this.ZykSocietyUserVisitCase = res.data;
          this.ZykSocietyUserVisitCase.firstTotal = res.data.firstTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykSocietyUserVisitCase.secondTotal = res.data.secondTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykSocietyUserVisitCase.dataList = [
            res.data.secondTimeSocietyNum,
            res.data.firstTimeSocietyNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykCourseVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykCourseVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库课程访问情况");
          this.ZykCourseVisitCase = res.data;
          this.ZykCourseVisitCase.firstTotal = res.data.firstTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykCourseVisitCase.secondTotal = res.data.secondTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykCourseVisitCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykResourceVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getCountryZykResourceVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级资源库资源访问情况");
          this.ZykResourceVisitCase = res.data;
          this.ZykResourceVisitCase.firstTotal = res.data.firstTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykResourceVisitCase.secondTotal = res.data.secondTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykResourceVisitCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          // console.log(this.ZykStudentUserVisitCase, 444);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.7.1 按资源量维度排名
    getYearReportCountryZykActiveResourceRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportCountryZykActiveResourceRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 555);
          this.sourceMater2171.dataList = res.data.value;
          this.sourceMater2171.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.7.2 按访问量维度排名
    getCountryZykBuildAnalysisLogRank_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykBuildAnalysisLogRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 555);
          this.sourceMater2172.dataList = res.data.value;
          this.sourceMater2172.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.7.3 按库内活跃用户数维度排名
    getYearReportCountryZykActiveUserRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportCountryZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 555);
          this.sourceMater2173.dataList = res.data.value;
          this.sourceMater2173.legendList = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.7.4 2022年综合应用排行排名
    getCompositeRank_Fun() {
      this.$axios
        .post(this.$apiurls.getCompositeRank, {
          loading: false,
        })
        .then((res) => {
          const firstChargeUnit1 = res.data.topFifteenRankList.firstChargeUnit;
          const zykName1 = res.data.topFifteenRankList.zykName;
          const zykNum1 = res.data.topFifteenRankList.zykNum;
          const firstChargeUnit2 = res.data.lastFifteenRankList.firstChargeUnit;
          const zykName2 = res.data.lastFifteenRankList.zykName;
          const zykNum2 = res.data.lastFifteenRankList.zykNum;
          this.disksNum_top = firstChargeUnit1.map((item, index) => {
            item = {
              firstChargeUnit: item,
              zykName: zykName1[index],
              zykNum: zykNum1[index],
            };
            return item;
          });
          this.disksNum_last = firstChargeUnit2.map((item, index) => {
            item = {
              firstChargeUnit: item,
              zykName: zykName2[index],
              zykNum: zykNum2[index],
            };
            return item;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.1.8 203个国家级资源库覆盖2021版专业目录情况分析
    getCountryZykCoverProfessionAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryZykCoverProfessionAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 777);
          const { data } = res;
          this.educationLevel218.dataList = [
            {
              value: data.coverMediumVocationalNum,
              name: "覆盖中职专业数",
            },
            {
              value: data.highVocational,
              name: "覆盖高职专业数",
            },
          ];
          this.educationLevel218.num = data.coverProfessionTotal;
          this.educationLevel218.num2 = data.highVocational;
          this.educationLevel218.num3 = data.coverMediumVocationalName;
          this.educationLevel218.num4 = data.repeatProfessionNum;
          this.educationLevel218.num5 = data.countryNotCounterZykNameList;
          this.educationLevel218.num6 = data.countryRepeatZykNameList;
          this.educationLevel218.num7 = data.countryCoverMediumVocational;
          this.educationLevel218.zykCount = data.zykCount;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2 国家及省市校级专业教学资源库运行监测情况分析
    getCountryProvinceCitySchoolLevelProfessionZykRunCase_Fun() {
      this.$axios
        .post(this.$apiurls.getCountryProvinceCitySchoolLevelProfessionZykRunCase, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 888);
          const { data } = res;
          this.runCase = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.1 用户建设及应用
    getUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 999);
          const { data } = res;
          this.analysis = data;
          const usernameArr = ["企业用户", "其他", "社会学习者", "学生", "教师"];
          const list = ["enterprise", "other", "social", "student", "teacher"];
          delete this.analysis.userMap.sum;
          this.analysis.userMap = usernameArr.map((item, index) => {
            item = {
              name: item,
              value: this.analysis.userMap[list[index]],
            };
            return item;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.2 课程建设及应用
    getCourseBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getCourseBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1000);
          const { data } = res;
          this.courseBuild = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.3 资源建设及应用
    getResourceBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getResourceBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1100);
          const { data } = res;
          this.getResource = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.4.1 各省资源库建设与应用情况概览
    getProvinceZykBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceZykBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1200);
          const { data } = res;
          this.getProvince = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    getProvinceUserBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceUserBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1300);
          const { data } = res;
          this.getProvinceUser = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getProvinceCourseBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceCourseBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1400);
          const { data } = res;
          this.CourseBuildAndAnalysis = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getProvinceZyBuildAndAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceZyBuildAndAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 1500);
          const { data } = res;
          this.ZyBuildAndAnalysis = data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.5.1 资源库学生用户新增情况
    getZykStudentUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykStudentUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级学生资源访问情况");
          this.ZykStudentUserNewAddCase = res.data;
          this.ZykStudentUserNewAddCase.firstTotal = res.data.studentFirstTimeNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUserNewAddCase.secondTotal = res.data.studentSecondTimeNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykStudentUserNewAddCase.dataList = [
            res.data.studentSecondTimeNum,
            res.data.studentFirstTimeNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.5.1 资源库学生用户新增情况
    getZykTeacherUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykTeacherUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [1],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级教师资源访问情况");
          this.ZykTeacherUserNewAddCase = res.data;
          this.ZykTeacherUserNewAddCase.firstTotal = res.data.firstTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUserNewAddCase.secondTotal = res.data.secondTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykTeacherUserNewAddCase.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.5.1 国家级企业资源访问情况
    getZykEnterpriseUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykEnterpriseUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级企业资源访问情况");
          this.ZykEnterpriseUserNewAddCase = res.data;
          this.ZykEnterpriseUserNewAddCase.firstTotal = res.data.firstTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUserNewAddCase.secondTotal = res.data.secondTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykEnterpriseUserNewAddCase.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 2.2.5.1 国家级社会学习者资源访问情况
    getZykSocietyUserNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykSocietyUserNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [3],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "国家级社会学习资源访问情况");
          this.ZykSocietyUserNewAddCase = res.data;
          this.ZykSocietyUserNewAddCase.firstTotal = res.data.firstTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykSocietyUserNewAddCase.secondTotal = res.data.secondTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.ZykSocietyUserNewAddCase.dataList = [
            res.data.secondTimeSocietyNum,
            res.data.firstTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykResourceNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykResourceNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [6],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库资源新增情况");
          this.getZykResourceNewAddCase = res.data;
          this.getZykResourceNewAddCase.firstTotal = res.data.firstTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykResourceNewAddCase.secondTotal = res.data.secondTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykResourceNewAddCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykCourseNewAddCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykCourseNewAddCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [5],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库课程新增情况");
          this.getZykCourseNewAddCase = res.data;
          this.getZykCourseNewAddCase.firstTotal = res.data.firstTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykCourseNewAddCase.secondTotal = res.data.secondTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykCourseNewAddCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykStudentUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykStudentUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库学生访问情况");
          this.getZykStudentUserVisitCase = res.data;
          this.getZykStudentUserVisitCase.firstTotal = res.data.firstTimeStudentNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykStudentUserVisitCase.secondTotal = res.data.secondTimeStudentNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykStudentUserVisitCase.dataList = [
            res.data.secondTimeStudentNum,
            res.data.firstTimeStudentNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykTeacherUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykTeacherUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [2],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库教师访问情况");
          this.getZykTeacherUserVisitCase = res.data;
          this.getZykTeacherUserVisitCase.firstTotal = res.data.firstTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykTeacherUserVisitCase.secondTotal = res.data.secondTimeTeacherNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykTeacherUserVisitCase.dataList = [
            res.data.secondTimeTeacherNum,
            res.data.firstTimeTeacherNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykEnterpriseUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykEnterpriseUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库企业访问情况");
          this.getZykEnterpriseUserVisitCase = res.data;
          this.getZykEnterpriseUserVisitCase.firstTotal = res.data.firstTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykEnterpriseUserVisitCase.secondTotal = res.data.secondTimeEnterpriseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykEnterpriseUserVisitCase.dataList = [
            res.data.secondTimeEnterpriseNum,
            res.data.firstTimeEnterpriseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykSocietyUserVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykSocietyUserVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库社会学习者访问情况");
          this.getZykSocietyUserVisitCase = res.data;
          this.getZykSocietyUserVisitCase.firstTotal = res.data.firstTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykSocietyUserVisitCase.secondTotal = res.data.secondTimeSocietyNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykSocietyUserVisitCase.dataList = [
            res.data.secondTimeSocietyNum,
            res.data.firstTimeSocietyNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykCourseVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykCourseVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [5],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库课程访问情况");
          this.getZykCourseVisitCase = res.data;
          this.getZykCourseVisitCase.firstTotal = res.data.firstTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykCourseVisitCase.secondTotal = res.data.secondTimeCourseNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykCourseVisitCase.dataList = [
            res.data.secondTimeCourseNum,
            res.data.firstTimeCourseNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykResourceVisitCase_Fun() {
      const { start, end } = this.getYearRange(this.nowYear - 1);
      this.$axios
        .post(
          this.$apiurls.getZykResourceVisitCase,
          {
            fistEndTime: end,
            fistStartTime: start,
            secondEndTime: this.endDay,
            secondStartTime: this.startDay,
            types: [6],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          console.log(res, "资源库资源访问情况");
          this.getZykResourceVisitCase = res.data;
          this.getZykResourceVisitCase.firstTotal = res.data.firstTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykResourceVisitCase.secondTotal = res.data.secondTimeResourceNum.reduce(
            (a, b) => a + b,
            0
          );
          this.getZykResourceVisitCase.dataList = [
            res.data.secondTimeResourceNum,
            res.data.firstTimeResourceNum,
          ];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getYearReportZykActiveResourceRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportZykActiveResourceRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "资源量排名");
          this.ZykActiveResourceRank = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykBuildAnalysisLogRank_Fun() {
      this.$axios
        .post(this.$apiurls.getZykBuildAnalysisLogRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "访问量排名");
          this.ZykBuildAnalysisLogRank = res.data.zykLogRankList;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getYearReportZykActiveUserRank_Fun() {
      this.$axios
        .post(this.$apiurls.getYearReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "访问量排名");
          this.ZykActiveUserRank = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getOnlineCourseYearRunAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseYearRunAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "年度运行监测总体情况");
          this.CourseYearRunAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getProvinceBuildCourseNum_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceBuildCourseNum, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "各省参建课程数量");
          this.ProvinceBuildCourseNum = res.data.onlineCourseRankByProvince.map((item) => {
            item = {
              name: item.province,
              value: item.total,
            };
            return item;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getProfessionBigClassCourseNum_Fun() {
      this.$axios
        .post(this.$apiurls.getProfessionBigClassCourseNum, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "归属专业大类分布情况");
          this.BigClassCourseNum.dataList = res.data.onlineCourseCategoryBuild;
          let total = 0;
          res.data.onlineCourseCategoryBuild.forEach((item) => {
            total += item.value;
          });
          this.BigClassCourseNum.total = total;
          // 数组排序
          function Sort(a, b) {
            return b.value - a.value;
          }
          this.BigClassCourseNum.dataList.sort(Sort);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getOnlineCourseVisitNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseVisitNum, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "在线精品课访问数据");
          this.OnlineCourseVisitNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getOnlineCourseOpenNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseOpenNum, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "在线精品课开课数据");
          this.OnlineCourseOpenNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getOnlineCourseSelectNum_Fun() {
      this.$axios
        .post(this.$apiurls.getOnlineCourseSelectNum, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "在线精品课程选课数据");
          this.OnlineCourseSelectNum = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getVideoCourseRunAnalysis_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseRunAnalysis, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "4、视频公开课运行监测情况分析");
          this.VideoCourseRunAnalysis = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getProvinceVideoCourseBuild_Fun() {
      this.$axios
        .post(this.$apiurls.getProvinceVideoCourseBuild, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "4.1 各省视频公开课建设情况");
          this.ProvinceVideoCourseBuild = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getVideoCourseVisit_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseVisit, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "4.2 视频公开课访问情况");
          this.VideoCourseVisit = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getVideoCourseSelect_Fun() {
      this.$axios
        .post(this.$apiurls.getVideoCourseSelect, {
          loading: false,
        })
        .then((res) => {
          console.log(res, "4.3 视频公开课选课情况");
          this.VideoCourseSelect = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 截取当前日期的赋值操作
    nowDate() {
      // let a = moment(new Date()).add('year', 0).format("YYYY-MM-DD")
      // let Frist = a.indexOf('-') + 1
      // let last = a.lastIndexOf('-') + 1
      // this.nowMonth = a.slice(Frist, last - 1) - 1
      // this.nowDay = a.slice(last, a.length)
      // console.log(this.nowMonth, this.nowDay);

      // let a = moment(new Date()).add('year', 0).format("YYYY-MM-DD")
      const Frist = this.$route.query.endDay.indexOf("-") + 1;
      const last = this.$route.query.endDay.lastIndexOf("-") + 1;
      const regx = /^[0]+/;
      this.nowMonth = this.$route.query.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.$route.query.endDay.slice(last, this.$route.query.endDay.length);
    },

    reload() {
      // 切换专业刷新视图层
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },

    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .post(
          this.$apiurls.exportMonthReport,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        })
        .catch(() => {
          this.loading.close();
        });
    },

    dataAllHandler() {
      this.$axios
        .post(this.$apiurls.getOverviewData, {
          loading: false,
        })
        .then((res) => {
          this.dataAll.dataList = res.data;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 各校等级,覆盖专业
    leaveHanderl() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getSchoolCollegeLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            const datas = [];
            for (let i = 0; i < res.data.dataList.length; i++) {
              datas.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }
            this.LeaveUp.dataList = datas;
            this.LeaveUp.Coveringspecialties = datas.find((item) => item.name == "覆盖专业");
            this.LeaveUp.vocationalschool = datas.find((item) => item.name == "高职");
            this.LeaveUp.Secondaryduty = datas.find((item) => item.name == "中职");
            this.LeaveUp.Vocational = datas.find((item) => item.name == "职教本科");
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 图 1 用户分布
    userTypeHandler() {
      this.$axios
        .post(this.$apiurls.getUserBuildApply, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.allReportUserForType.value.length; i++) {
            this.userTypeHand.total += res.data.allReportUserForType.value[i];
            this.userTypeHand.dataList.push({
              name: res.data.allReportUserForType.name[i],
              value: res.data.allReportUserForType.value[i],
            });
          }
          // 教师数量
          const tearch = this.userTypeHand.dataList.find((item) => item.name == "教师");
          this.userTypeHand.tearchNum = tearch.value;
          // 学生数
          const student = this.userTypeHand.dataList.find((item) => item.name == "学生");
          this.userTypeHand.studentNum = student.value;
          this.userTypeHand.legendList = res.data.allReportUserForType.name;
          // this.userTypeHand.dataList = datas

          this.userTalk.dataList.push(
            res.data.userMonthVisits.teacher.value,
            res.data.userMonthVisits.student.value
          );
          this.userTalk.transverse = res.data.userMonthVisits.student.name;
          this.userTalk.teacherTotal =
            res.data.userMonthVisits.teacherTotal > 100000000
              ? `${(res.data.userMonthVisits.teacherTotal / 100000000).toFixed(2)}亿`
              : `${(res.data.userMonthVisits.teacherTotal / 10000).toFixed(2)}万`;
          this.userTalk.studentTotal =
            res.data.userMonthVisits.studentTotal > 100000000
              ? `${(res.data.userMonthVisits.studentTotal / 100000000).toFixed(2)}亿`
              : `${(res.data.userMonthVisits.studentTotal / 10000).toFixed(2)}万`;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 图 1 当前资源库资源、课程情况
    // userType() {
    //   this.$axios
    //     .post(this.$apiurls.monitoringCloud_getUserTypeDistribute, {
    //       loading: false,
    //     })
    //     .then((res) => {
    //       if (res) {
    //         let datas = [];
    //         for (let i = 0; i < res.data.name.length; i++) {
    //           this.userTypeList.total += res.data.value[i];
    //           datas.push({ name: res.data.name[i], value: res.data.value[i] });
    //         }

    //         // 教师数量
    //         let tearch = datas.find((item) => item.name == "教师");
    //         this.userTypeList.tearchNum = tearch.value;
    //         // 学生数
    //         let student = datas.find((item) => item.name == "学生");
    //         this.userTypeList.studentNum = student.value;
    //         this.userTypeList.legendList = res.data.name;
    //         this.userTypeList.dataList = datas;
    //       }
    //     });
    // },

    // 图 3 課程數量
    courseNum() {
      this.$axios
        .post(this.$apiurls.getCourseBuildApply, {
          loading: false,
        })
        .then((res) => {
          this.courseTypeNum.dataList.push(
            {
              name: "资源库课程数",
              value: res.data.zykCourseCount,
            },
            {
              name: "在线精品课数",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课数",
              value: res.data.videoCourseNum,
            }
          );

          this.courseTypeNum.dataList.forEach((item) => {
            this.courseTypeNum.total += item.value;
          });
          // 最大值得数组
          function sortMax(a, b) {
            return b.value - a.value;
          }
          this.courseTypeNum.dataList.sort(sortMax);
          this.courseTypeNum.maxArr = this.courseTypeNum.dataList[0];
          this.courseTypeNum.schoolNum.push({
            name: "参建院校",
            value: res.data.schoolNum,
          });
          this.courseTypeNum.companyNum.push({
            name: "参建企业",
            value: res.data.companyNum,
          });
          this.resource.dataList = res.data.courseYearMonthVisits.resource.value;
          this.courseTalk.dataList = res.data.courseYearMonthVisits.course.value;
          this.courseTalk.transverseData = res.data.courseYearMonthVisits.course.name;
          this.courseTalk.dataList.forEach((item) => {
            this.courseTalk.total += item;
          });

          this.courseTalkTable.dataList = res.data.courseVisitsRank;
          this.courseTalkTable.dataList.forEach((item) => {
            if (item.courseName.length > 8) {
              item.courseName = `${item.courseName.slice(0, 9)}...`;
            }
            this.courseTalkTable.total += item.courseTotalVisit;
          });

          function Sort(a, b) {
            return b.courseTotalVisit - a.courseTotalVisit;
          }
          this.courseTalkTable.dataList.sort(Sort);
          this.courseTalkTable.MaxArr = this.courseTalkTable.dataList[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    zykCourseRankHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseRank, {
          loading: false,
        })
        .then((res) => {
          this.zykCourseRanks.dataList = res.data;

          this.zykCourseRanks.dataList.forEach((item) => {
            this.$set(item, "names", item.name);
            if (item.name.length > 8) {
              item.name = `${item.name.slice(0, 8)}...`;
            }
          });
          this.zykCourseRanks.MaxArr = this.zykCourseRanks.dataList[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 各类型资源存储量
    resourcesNumber() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getResourceCount, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.dataList.length; i++) {
            this.typeResources.dataList.push({
              name: res.data.transverseData[i],
              value: res.data.dataList[i],
            });
          }
          this.typeResources.sucai = this.typeResources.dataList.find(
            (item) => item.name == "素材资源"
          );
          this.typeResources.rongliang = this.typeResources.dataList.find(
            (item) => item.name == "资源存储量"
          );
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 资源类型占比
    resourcesProportion() {
      this.$axios
        .post(this.$apiurls.getResourceBuildApply, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.resourceTypes.name.length; i++) {
              this.educationLevel.total += res.data.resourceTypes.value[i];
              this.educationLevel.dataList.push({
                name: res.data.resourceTypes.name[i],
                value: res.data.resourceTypes.value[i],
              });
            }

            function Sort(a, b) {
              return a.value - b.value;
            }
            this.educationLevel.dataList.sort(Sort);

            this.educationLevel.Max = this.educationLevel.dataList[0];
            this.educationLevel.totalVisitNum = res.data.totalVisitNum;
            this.educationLevel.resourceCapacityNum = res.data.resourceCapacityNum;

            res.data.reportResourceRank;
            this.educationLevel.video = this.educationLevel.dataList.find(
              (item) => item.name == "视频"
            );
            this.educationLevel.dataList.forEach((item) => {
              this.educationLevel.transverseData.push(item.name);
            });
            this.educationLevel.xuni = this.educationLevel.dataList.find(
              (item) => item.name == "虚拟仿真"
            );

            this.resourceTable.dataList = res.data.reportResourceRank.resourceRank;
            this.resourceTable.resourceTotal = res.data.reportResourceRank.resourceTotal;
            this.resourceTable.resourceAvg = res.data.reportResourceRank.resourceAvg;
            this.resourceTable.MaxArr = this.resourceTable.dataList;

            function Sort1(a, b) {
              return b.num - a.num;
            }
            this.resourceTable.MaxArr.sort(Sort1);
            this.resourceTable.Max = this.resourceTable.MaxArr[0].name;
            // this.resourceTable.dataList.forEach((item) => {
            //   if (item.name.length > 8 || item.zykName.length > 8) {
            //     item.name = item.name.slice(0, 8) + '...';
            //     item.zykName = item.zykName.slice(0, 8) + '...';
            //   }

            //   let index = item.name.indexOf(",") + 1;
            //   let type = item.name.slice(index);
            //   let name = item.name.slice(0, index - 1);
            //   this.$set(item, "resourceType", type);
            //   this.$set(item, "name", name);
            // });

            const datasMax = this.educationLevel.Max;
            datasMax.name += "类";

            const some = this.resourceTable.dataList.find(
              (item) => item.resourceType == datasMax.name
            );
            this.resourceTable.MaxZykname = some;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 监测云图_各等级资源库数量
    resourceLevelHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getResourceBaseLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.resourceLevel.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }
            this.resourceLevel.total = this.resourceLevel.dataList.find(
              (item) => item.name == "资源库总数"
            ).value;
            this.resourceLevel.countryNum = this.resourceLevel.dataList.find(
              (item) => item.name == "国家级"
            );
            this.resourceLevel.provinceNum = this.resourceLevel.dataList.find(
              (item) => item.name == "省市级"
            );
            this.resourceLevel.schoolNum = this.resourceLevel.dataList.find(
              (item) => item.name == "院校级"
            );
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 用户建设及应用情况
    userConstructionHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getCoreIndicators, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.userConstruction.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }

            this.userConstruction.userData = this.userConstruction.dataList.filter(
              (item) => item.name != "标准化课程"
            );
            this.userConstruction.userData = this.userConstruction.dataList.filter(
              (item) => item.name != "参建院校"
            );

            this.userConstruction.userData.find((item) => item.name == "学生");
            this.userConstruction.userData.find((item) => item.name == "教师");

            this.userConstruction.tearchNum = this.userConstruction.userData.find(
              (item) => item.name == "教师"
            );
            this.userConstruction.socialNum = this.userConstruction.userData.find(
              (item) => item.name == "社会学习者"
            );
            this.userConstruction.studentNum = this.userConstruction.userData.find(
              (item) => item.name == "学生"
            );
            this.userConstruction.EnterpriseNum = this.userConstruction.userData.find(
              (item) => item.name == "企业用户"
            );

            const newArr = [];
            newArr.push(
              this.userConstruction.tearchNum,
              this.userConstruction.socialNum,
              this.userConstruction.studentNum,
              this.userConstruction.EnterpriseNum
            );

            newArr.forEach((item) => {
              this.userConstruction.total += item.value;
            });

            this.userConstruction.standardcourse = this.userConstruction.dataList.find(
              (item) => item.name == "标准化课程"
            );

            this.userConstruction.userTotal =
              this.userConstruction.tearchNum.value +
              this.userConstruction.socialNum.value +
              this.userConstruction.studentNum.value +
              this.userConstruction.EnterpriseNum.value;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 近一年社会学习者和企业用户访问情况
    socialAenterpriseHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserMonthVisits, {
          loading: false,
        })
        .then((res) => {
          const datas1 = [];
          const datas2 = [];
          res.data.enterprise.forEach((item) => {
            datas1.push(item.value);
          });
          res.data.social.forEach((item) => {
            datas2.push(item.value);
          });
          this.socialAndenterprise.dataList.push(datas1, datas2);
          this.socialAndenterprise.transverse = res.data.student.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 课程整体情况
    courseAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseState, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseDataAll.name = res.data.name;
            this.courseDataAll.zykDiv = res.data.zykDiv;
            this.courseDataAll.zykName = res.data.zykName;
          }
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    getzykACtiveHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykACtive.colorList = this.colorList;
          res.data.forEach((item) => {
            this.getzykACtive.dataList.push(item.value);
            this.getzykACtive.transverseData.push(item.name);
          });

          this.getzykACtive.Frist = res.data[0];
          this.getzykACtive.Second = res.data[1];
          this.getzykACtive.Thrid = res.data[2];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 资源库课程介绍
    curriculProvinceHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.curriculProvince.dataList = res.data.courseRank;
          this.curriculProvince.MaxArr = this.curriculProvince.dataList[0];
          this.curriculProvince.SerArr = this.curriculProvince.dataList[1];

          res.data.courseRank.forEach((item) => {
            this.curriculProvince.total += item.num;
            this.curriculProvince.stotal += item.snum;
            this.curriculProvince.ptotal += item.pnum;
          });
          res.data.standard = this.curriculProvince.dataList.find((item) => item.name == "湖南省");
          this.curriculProvince.standard = res.data.standard;

          res.data.personality = this.curriculProvince.dataList.find(
            (item) => item.name == "广东省"
          );
          this.curriculProvince.personality = res.data.personality;
        });
    },

    // 资源库省份资源建设情况
    disksNumHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKResourceProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          console.log(res, 777);
          this.disksNum.maxProvince = res.data.maxProvince;
          this.disksNum.dataList = res.data.provinceRank;

          this.disksNum.MaxArr = this.disksNum.dataList[0];
          this.disksNum.dataList.forEach((item) => {
            this.disksNum.total += item.log;
            this.disksNum.totalLog += item.count;
          });

          this.disksNum.buildMaxArr = this.disksNum.dataList;

          this.disksNum.buildMax = res.data.maxProvince;
        });
    },

    // 资源库用户运行情况
    zykuserYunHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKUserActiveStatus,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 累计活跃用户
          // （1）资源库用户月活情况分析
          this.zykuserYun.userActiveTotal = res.data.userActiveTotal;
          const datas1 = [];
          const datas2 = [];
          res.data.userActiveMonth.forEach((item) => {
            datas1.push(item.value);
            datas2.push(item.name);
            this.zykuserYun.userActiveTotals += item.value;
          });
          this.zykuserYun.userActiveData = datas1;
          this.zykuserYun.userActiveTranserve = datas2;

          // （2）资源库用户访问情况分析
          // 标题数据统计
          res.data.userActive.forEach((item) => {
            this.zykuserYun.userActivelogNum += item.logNum;
          });
          // 创建一个新数组
          const newRoleArr = res.data.userActive.map((item) => {
            const { num } = item;
            const { logNum } = item;
            const { role } = item;
            return {
              num,
              logNum,
              role,
            };
          });

          // 单独的每位用户数组
          this.zykuserYun.roleStudent = newRoleArr.find((item) => item.role == "学生");
          this.zykuserYun.roleTeacher = newRoleArr.find((item) => item.role == "教师");
          this.zykuserYun.roleEnterprise = newRoleArr.find((item) => item.role == "企业用户");
          this.zykuserYun.roleSocial = newRoleArr.find((item) => item.role == "社会学习者");

          this.zykuserYun.userActiveRoleData = res.data.userActiveMonthRole.dataList;
          this.zykuserYun.userActiveRoleTranserve = res.data.userActiveMonthRole.transverseData;
          this.zykuserYun.userActiveRolelegendList = res.data.userActiveMonthRole.legendList;
          this.zykuserYun.colorList = this.colorList;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 资源库被用户访问情况排名分析
    fristAlast() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKVisitsRank,
          {
            endDay: this.endDay,
            startDay: this.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userTop.fristTop15 = res.data.slice(0, 15);
          this.userTop.fristMax = this.userTop.fristTop15[0];

          this.userTop.last15 = res.data.slice(-15);
          this.userTop.lastMax = this.userTop.last15[this.userTop.last15.length - 1];
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.userTop.last15.sort(Sort);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 资源库资源运行情况
    zyktalkHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKResourceStatus,
          {
            endDay: this.$route.query.endDay,
            startDay: this.$route.query.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zyktalk.total = res.data.total;
          this.zyktalk.totalLog = res.data.totalLog;
          this.zyktalk.newRank = res.data.newRank;
          this.zyktalk.Top = res.data.newRank[0];

          this.zyktalk.logRank = res.data.logRank;

          function Sort(a, b) {
            return b.num - a.num;
          }

          this.zyktalk.logRank.sort(Sort);
          this.zyktalk.MaxArr = this.zyktalk.logRank[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    // 资源库用户新增情况分析
    CountryUserAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZykUserMonthNew,
          {
            endDay: this.$route.query.endDay,
            startDay: this.$route.query.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryUserAdd.dataList.push(res.data.student.value, res.data.teacher.value);
          this.CountryUserAdd.transverseData = res.data.teacher.name;

          res.data.teacher.value.forEach((item) => {
            this.CountryUserAdd.Stotal += item;
          });

          res.data.student.value.forEach((item) => {
            this.CountryUserAdd.Ttotal += item;
          });
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    CountryCurAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKUserActiveStatus,
          {
            endDay: this.$route.query.endDay,
            startDay: this.$route.query.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 月活
          res.data.userActiveMonth.forEach((item) => {
            this.CountryCurAdd.userActiveMonthdataList.push(item.value);
            this.CountryCurAdd.userActiveMonthTransverseData.push(item.name);
          });
          this.CountryCurAdd.userActiveTotal = res.data.userActiveTotal;

          // 用户月活 + 访问
          this.CountryCurAdd.teacherActive = res.data.userActive.find(
            (item) => item.role == "教师"
          );
          this.CountryCurAdd.studentActive = res.data.userActive.find(
            (item) => item.role == "学生"
          );
          this.CountryCurAdd.societyActive = res.data.userActive.find(
            (item) => item.role == "社会学习者"
          );
          this.CountryCurAdd.enterpriseActive = res.data.userActive.find(
            (item) => item.role == "企业用户"
          );
          const totalNum1 = this.CountryCurAdd.teacherActive.num;
          const totalNum2 = this.CountryCurAdd.studentActive.num;
          const totalNum3 = this.CountryCurAdd.societyActive.num;
          const totalNum4 = this.CountryCurAdd.enterpriseActive.num;

          const logNum1 = this.CountryCurAdd.teacherActive.logNum;
          const logNum2 = this.CountryCurAdd.studentActive.logNum;
          const logNum3 = this.CountryCurAdd.societyActive.logNum;
          const logNum4 = this.CountryCurAdd.enterpriseActive.logNum;
          this.CountryCurAdd.num = totalNum1 + totalNum2 + totalNum3 + totalNum4;
          this.CountryCurAdd.logNum = logNum1 + logNum2 + logNum3 + logNum4;

          // 用户访问趋势图
          this.CountryCurAdd.userVisitDataList = res.data.userActiveMonthRole.dataList;
          this.CountryCurAdd.userVisitTransverseData = res.data.userActiveMonthRole.transverseData;
          this.CountryCurAdd.userVisitLegendList = res.data.userActiveMonthRole.legendList;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    CountryVisitsRank() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKVisitsRank,
          {
            endDay: this.$route.query.endDay,
            startDay: this.$route.query.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryVisit.FristdataList = res.data.slice(0, 15);
          this.CountryVisit.FristZykVisit = this.CountryVisit.FristdataList[0];
          this.CountryVisit.LastdataList = res.data.slice(-15);
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.CountryVisit.LastdataList.sort(Sort);
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 获取区间内国家级资源库课程新增趋势
    CountryCuourseAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZykMonthRange,
          {
            startDay: this.$route.query.startDay,
            endDay: this.$route.query.endDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          res.data.value.forEach((item) => {
            this.CountryCuourse.courseTotal += item;
          });
          this.CountryCuourse.dataList = res.data.value;
          this.CountryCuourse.transverseData = res.data.name;
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    // 区间内国家级资源库课程访问量排名
    CountryCurVisitHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCountryZyKCourseRank, {
          loading: false,
        })
        .then((res) => {
          this.CountryCourseVisit.dataList = res.data;
          this.CountryCourseVisit.Max = res.data[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    CountryResourcesAddHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCountryZyKResourceStatus,
          {
            endDay: this.$route.query.endDay,
            startDay: this.$route.query.startDay,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.CountryResourcesAdd.total = res.data.total;
          this.CountryResourcesAdd.totalLog = res.data.totalLog;
          this.CountryResourcesAdd.newRank = res.data.newRank;
          this.CountryResourcesAdd.logRank = res.data.logRank;
          this.CountryResourcesAdd.visitRankTop1 = this.CountryResourcesAdd.logRank[0];
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getCountryZykVisitCaseTotalByType() {
      this.$axios
        .post(
          this.$apiurls.getCountryZykVisitCaseTotalByType,
          {
            fistStartTime: this.$route.query.startDay,
            fistEndTime: this.$route.query.endDay,
            types: [1, 2, 3, 4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.countryZykTotalVisit = res.data.totalVisitNum;
          console.log(res, "2.1.6.4 国家级资源库累计访问量");
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },
    getZykVisitCaseTotalByType() {
      this.$axios
        .post(
          this.$apiurls.getZykVisitCaseTotalByType,
          {
            fistStartTime: this.$route.query.startDay,
            fistEndTime: this.$route.query.endDay,
            types: [1, 2, 3, 4],
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zykTotalVisit = res.data.totalVisitNum;
          this.allLevelTotalLoginUser = res.data.allLevelTotalLoginUserNum;
          console.log(res, "2.2.5.4 资源库累计访问量");
          this.completeMathodNum = this.completeMathodNum + 1;
        });
    },

    changeCity(data) {
      if (data == "北京" || data == "上海" || data == "天津" || data == "重庆") {
        return `${data}市`;
      }
      return `${data}省`;
    },
    dataHandler(data) {
      return data > 100000000
        ? `${(data / 100000000).toFixed(2)}亿`
        : data > 10000
        ? `${(data / 10000).toFixed(2)}万`
        : data;
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  /* height: 65760px; */
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  width: 86.7%;
  margin: 0px auto;
  height: 104466px;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
  font-size: 40px;
}

.header_titles h1 {
  font-size: 60px;
  font-weight: bold;
  color: #1d244e;
  line-height: 70px;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
  margin: 100px 0px;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 40px;
  color: #1d244e;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}
.chart_box,
.catalogue h3 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h3 {
  font-size: 50px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
  /*text-indent: 40px;*/
  /* line-height: 40px; */
  margin-bottom: 15px;
  margin-top: 50px;
}
.chart_box h4 {
  font-size: 45px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 30px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 40px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}
.chart_box p {
  font-weight: 540 !important;
  font-size: 28px !important;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f !important;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  /* height: auto; */
  /* height: 400px; */
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 33px;
  font-size: 22px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}
.biaoge {
  height: 720px;
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}
::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-top: 20%;
  padding-left: 10%;
}

.HomePage #image {
  width: 700px;
  height: 150px;
  background: url("../../../../public/pdf.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 45% 0px 40% 0px;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 55px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 4.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  padding: 10% 0px 0px 10%;
  margin-top: 300px;
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}
.top {
  margin-top: 140px;
}
</style>
